// Angular
import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { Router } from '@angular/router';

// Ionic
import {
  IonContent,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonIcon,
  ModalController,
  AlertController,
  IonPopover,
  PopoverController
} from '@ionic/angular/standalone';
import { Platform } from '@ionic/angular';

// Local library
import {
  CommonFacade,
  PermissionService,
  SessionService
} from '@amwager/data-access';
import {
  RaceStringToRangePipe,
  GetCurrentRacePipe,
  GetRaceStatusPipe,
  SortEventsPipe,
  GetEventStatusPipe,
  GetTrackTypePipe,
  ConvertToRangePipe,
  LegHeightDirective,
  OrdinalsPipe,
  HorseWeightPipe,
  UnsubscribeObservableService,
  FormatAmountPipe,
  MatrixDataPipe,
  EmptySuitPipe,
  GetTrackIconPipe,
  GeoLocationService
} from '@amwager/util';
import {
  GUEST,
  IGeoLocationModel,
  IGetEventsDetailsResponse,
  ILeg,
  IPool,
  IRace,
  wager,
  leg,
  dutchAmounts,
  calcBets,
  countBets,
  ticketRequest,
  dutchWagersService,
  winDutchService,
  abcWagersService
} from '@amwager/util-ts';
import {
  IBetStackTicket,
  IBetTicket,
  IReplays,
  ISelectedRace,
  ISelectedRaceMatrix,
  WagerFacade
} from '@amwager/wager/data-access';
import { AccountFacade } from '@amwager/account/data-access';
import { AuthFacade } from '@amwager/authentication/data-access';
import { Observable, Subscription, concatMap, filter, from, map, of, takeUntil } from 'rxjs';
import { FundingComponent } from '@amwager/funding/feature-ion';
import { BetSlipModalComponent } from "@amwager/ticket/feature-ion";
import * as _ from 'lodash';
import { ShowRunnerInfoComponent } from '../show-runner-info/show-runner-info.component';
import { RunnerReplaysModalComponent } from '../runner-replays/runner-replays.component';
import { BetAmountComponent } from '../bet-amount/bet-amount.component';

// import { Geolocation } from '@capacitor/geolocation';
// import { AuthFacade } from '@amwager/authentication/data-access';

// Capacitor
import { Capacitor } from '@capacitor/core';

// Third party
import { NativeSettings, AndroidSettings } from 'capacitor-native-settings';
import { DutchComponent } from '../dutch/dutch.component';
import { AbcComponent } from '../abc/abc.component';

@Component({
  selector: 'feature-ion-runner',
  standalone: true,
  imports: [
    CommonModule,
    IonContent,
    IonButton,
    IonSelect,
    IonSelectOption,
    IonIcon,
    IonPopover,
    RaceStringToRangePipe,
    GetCurrentRacePipe,
    GetRaceStatusPipe,
    SortEventsPipe,
    GetEventStatusPipe,
    GetTrackTypePipe,
    ConvertToRangePipe,
    LegHeightDirective,
    OrdinalsPipe,
    HorseWeightPipe,
    FormatAmountPipe,
    MatrixDataPipe,
    EmptySuitPipe,
    GetTrackIconPipe
  ],
  providers: [DatePipe],
  templateUrl: './runner.component.html',
  styleUrls: ['./runner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RunnerComponent extends
  UnsubscribeObservableService implements
  OnInit, OnChanges, AfterViewChecked {
  @Input() events!: any;
  @Input() selectedEvent!: IGetEventsDetailsResponse;
  @Input() selectedRace!: ISelectedRace;
  @Input() isShowRunnners = false;
  @Input() selectedPool!: IPool;
  @Input() selectedModifier!: string;
  @Input() setBaseAmount!: number;
  @Input() dblPkArray!: any;
  @Input() triggerLiveVideo!: boolean;
  @Input() poolMatrix!: any;

  @ViewChild('wagingSectionTemplateRef') wagingSectionTemplateRef!: ElementRef;
  @ViewChild('runnerRef') runnerRef!: ElementRef;
  @ViewChildren('runnerInfo') runnersInfo!: QueryList<ElementRef>;
  @ViewChildren('legsInfo') legsInfo!: QueryList<ElementRef>;
  @ViewChildren('currentEntries') currentEntries!: QueryList<ElementRef>;
  @ViewChildren('currentRunners') currentRunners!: QueryList<ElementRef>;

  geoLocation!: IGeoLocationModel;
  private getSelectedEventTrackSubs!: Subscription;

  setRunnerScrollTimeout: any;
  triggerSetRunnerHeight: boolean = false;

  prevPoolId: string = '';
  prevModifierId: string = '';
  PoolIds: string[] = ['EX','QU','TRL','TRI','SPR','OMN','PEN','HEX'];
  vertical: string[] = ['EX','TRI','SPR','PEN','HEX'];
  horizontal: string[] = ['DBL'];

  // private subsUserAccountResponse!: Subscription;
  // event$!: Observable<IGetEventsDetailsResponse[]>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details$!: Observable<any[]>;
  event$!: Observable<IGetEventsDetailsResponse[]>;
  ticket$!: Observable<IBetTicket>;
  ticket!: IBetTicket;
  baseAmount!: number;
  balanceAmount!: number;

  bets!: number;
  runners!: string;
  legs!: ILeg[];
  legResult: any[] = [];

  storeStructure: { leg: any, runners: any[] }[] = [];
  storeStructureCopy!: any;
  storedSelectedRunners = '';
  cantBet!: boolean;
  showCurrentInfo!: number;

  isShowFooter:boolean = false;
  isShowBetPreview:boolean = false;

  isClearWager!:boolean;
  requireConfirmation!: boolean;
  isExoticSelections!: boolean;
  maxWagerTotal!: number;
  isWagerLimit: boolean = false;
  wagerLimit: number = 0;

  setTimer: number = 0;
  isProcessingBet: boolean = false;
  replayTypes: number[] = [0, 4, 2, 1, 3];
  // wager replays
  runnerWithReplays: any[] = [];
  // indexPostReplays: number = 0;
  indexGetReplays: number = 0;


  dutchTicket!: any;
  runnersWithStake!: any;
  dutchROI: string = '';
  dutchTotalAmount: number = 0;
  setTimerABC: number = 0;
  nestedRunnersABC!: any;
  abcTicket!: any;
  abcTotalAmount: number = 0;
  dutchAbcErrorMsg!: any;
  disableSavedBetBtn: boolean = false;
  disableBetNowBtn: boolean = false;
  countryStateList!: any;
  isBlockJurisdiction: boolean = false;
  isBlockJurisdictionMsg: string = '';

  isExceedsSaveBetErr: boolean = false;
  isExceedsBetNowErr: boolean = false;
  isGenericSaveBetErr: boolean = false;
  isGenericBetNowErr: boolean = false;

  private subsGetBetResponse!: Subscription;
  private betStackTicketPayload: IBetStackTicket = {
    EventId: '',
    RaceId: 0,
    BaseAmount: 0,
    PoolId: "",
    Runners: null,
    Modifier: 0,
    DutchType: 0,
    Condition: null
  }
  private betTicketPayload: IBetTicket = {
    CustomerId: '',
    DutchType: 0,
    FileUploadName: null,
    // Location: {
    //   CLat: 0,
    //   CLon: 0
    // },
    NickName: null,
    RunId: '',
    TicketAmount: 0,
    ToteTicketRequest: {
      CurrencyId: 'USD',
      EventId: '',
      ParentStackId: "",
      RaceId: 0,
      StackId: "",
      Wagers: [{
        // RaceId: 0,
        BaseAmount: 0,
        // BaseAmount: '',
        Bets: 0,
        Legs: [{
          Auto: false,
          Runners: ""
        }],
        Modifier: 0,
        PoolId: "",
        Total: 0
      }]
    }
  }

  private clientGeo!: {
    latitude: number;
    longitude: number;
  };

  matrix: any;
  dutchEnam: string[] = [
    'None',
    'DutchCost',
    'DutchPayout',
    'ABC'
  ];
  nestedArrayABC: {
    runnerId: number; legId: number; value: string
  }[][] = [];
  abcArray: string[] = ['A', 'B', 'C', ''];
  modifierEnam: string[] = [
    'Straight',
    'Wheel',
    'Box',
    'PowerBox',
    'Leading',
    'KeyWheel',
    'KeyBox',
    'DutchCost',
    'DutchPayout',
    'ABC'
  ];

  private modal!: HTMLIonModalElement;

  private previousSelectedRaceID!: string;
  private isClearCustomState = false;

  private showAlertInfoHandler?: HTMLIonAlertElement;
  private isRequireConfirmActiveHandler?: HTMLIonAlertElement;
  private showAlertGeoLocationHandler?: HTMLIonAlertElement;
  private showAlertWagerLimitHandler?: HTMLIonAlertElement;
  private showAlertErrorHandler?: HTMLIonAlertElement;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly permissionService: PermissionService,
    private readonly sessionService: SessionService,
    private geoLocationService: GeoLocationService,
    private readonly router: Router,
    private readonly elementRef: ElementRef,
    private renderer: Renderer2,
    private readonly modalCtrl: ModalController,
    private readonly alertCtrl: AlertController,
    private readonly popoverController: PopoverController,
    private readonly wagerFacade: WagerFacade,
    private readonly accountFacade: AccountFacade,
    private readonly authFacade: AuthFacade,
    private readonly commonFacade: CommonFacade,
    // private readonly authFacade: AuthFacade,
    private readonly platform: Platform,
    private readonly ngZone: NgZone
  ) {

    super();

    this.observerGetRaceMatrix();
    this.observerLogout();
  }

  ngOnInit() {

    this.clientGeo = {
      latitude: 0,
      longitude: 0
    };
    // this.baseAmount = 1;
    this.balanceAmount = 0;
    this.bets = 0;
    this.runners = '';

    this.wagerFacade.getTicketGeoLocation$().subscribe((response?: IGeoLocationModel) => {
      if (response === undefined) return;
      // console.log("runner:location:", response)
      this.geoLocation = response;
    });

    this.accountFacade.getBalance$()
      .subscribe((res) => {
        if (res !== undefined) {
          this.balanceAmount = res;
        }
        this.cdRef.markForCheck();
      });

    this.commonFacade.setIsShowFooter(true);
    this.commonFacade.isShowFooter$().subscribe((isShow: boolean) => {
      this.isShowFooter = isShow;
      this.cdRef.markForCheck(); // re-render for template
    });

    this.wagerFacade.isShowBetPreview$().subscribe((isShow: boolean) => {
      this.isShowBetPreview = isShow;
      this.cdRef.markForCheck(); // re-render for template
    });

    this.showCurrentInfo = 0;
    if (this.selectedRace !== undefined) {
      this.showCurrentInfo = this.selectedRace.RaceId as number;

      const spanLegs = this.elementRef.nativeElement.querySelectorAll(
        '.waging-section .mode-place-races .head-bet #race'
      );
      // const spanLegs = this.elementRef.nativeElement.querySelectorAll(
      //   '.waging-section .mode-place-races .head-bet [id^="race"]'
      // );
      spanLegs.forEach((leg: HTMLElement) => {
        leg?.classList.add('active');
        return true;
      });
    }

    this.accountFacade.isGetAccountPreferencesSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((callback) => {

        if (callback === undefined) return;

        const response = callback?.response;
        this.isClearWager = response?.AccountPreferences?.IsClearWager;
        this.requireConfirmation = response?.AccountPreferences?.RequireConfirmation;
        this.isExoticSelections = response?.AccountPreferences?.IsExoticSelections;
        this.isWagerLimit = response?.AccountPreferences?.IsWagerLimit;
        this.wagerLimit = response?.AccountPreferences?.WagerLimit;
        this.maxWagerTotal = response?.ToteResponse?.Limits?.MaxWagerTotal;
        this.cdRef.markForCheck();
      });

    // this.authFacade.jurisdictions('US');
    this.authFacade.getCountryStates$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response}) => {
        if (response !== undefined)
          this.countryStateList = response;
      });

    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
        if (isLogout) {
          this.clearLegRoundSelector();
          this.clearCustomState();
        }
      });

    // this.wagerFacade.getReplays$()
    //   .subscribe((replays?: IReplays) => {

    //     if (replays?.isSuccess !== undefined)
    //       this.indexPostReplays = this.indexPostReplays + 1;

    //     if (replays?.response !== undefined && replays?.isSuccess !== undefined) {

    //       const availableVideos = replays?.response?.AvailableVideos;

    //       _.flatMap(availableVideos, (event) => {
    //         _.map(event, (item, breed) => {
    //           _.map(item, (data) => {
    //             const video = {
    //               track: data?.EventName,
    //               trackId: data?.TrackId,
    //               date: data?.RaceDay,
    //               breed,
    //               race: data?.RaceId,
    //               distance: data?.Distance,
    //               surface: data?.Surface,
    //               purse: data?.Purse,
    //             };

    //             const runner = this.runnerWithReplays[this.indexPostReplays-1];
    //             runner.availableReplays = [...runner.availableReplays, video];

    //           });
    //         });
    //       });

    //       this.runnerWithReplays.forEach((runner) => {
    //         runner.availableReplays = _.orderBy(
    //           runner.availableReplays,
    //           ['date', 'race', 'track'],
    //           ['desc', 'asc', 'asc']
    //         );
    //       });

    //     }

    //     this.cdRef.markForCheck();
    //   });
  }

  // ngOnChanges(changes: SimpleChanges): void {

  //   if (this.selectedPool !== undefined) {
  //     this.baseAmount = this.selectedPool.WagerMinimum;
  //   }

  //   this.storeStructure = [];

  //   this.clearActiveAllLeg();
  //   // this.sumSelectedLegs();

  //   // console.log(this.storeStructure);

  //   this.showBet();
  // }

  ngOnChanges(changes: SimpleChanges): void {

    // console.log('RACE:onchanges:runner:ngOnChanges:', changes);

    // console.log('RACE:onchanges:runner:previousSelectedRaceID:old:', this.previousSelectedRaceID);

    if (changes['selectedRace'] !== undefined && changes['selectedRace'].currentValue !== undefined) {
      if ((changes['selectedRace'].currentValue.eventId + '-' + changes['selectedRace'].currentValue.RaceId)
          !== this.previousSelectedRaceID
      ) {
        this.previousSelectedRaceID = changes['selectedRace'].currentValue.eventId + '-' + changes['selectedRace'].currentValue.RaceId;
        this.isClearCustomState = true;

        // console.log('RACE:onchanges:runner:previousSelectedRaceID:new:', this.previousSelectedRaceID);
      }
      else this.isClearCustomState = false;

      // console.log('RACE:onchanges:runner:ngOnChanges:RaceStatus:', changes['selectedRace']?.currentValue?.RaceStatus);

      // if (changes['selectedRace'].currentValue.RaceStatus !== 0) this.isClearCustomState = true;
    }


    if (changes['triggerLiveVideo'] !== undefined) {
      if (
        changes['triggerLiveVideo'].currentValue ||
        !changes['triggerLiveVideo'].currentValue
      ) {
        this.triggerSetRunnerHeight = changes['triggerLiveVideo'].currentValue;
        this.setRunnerScroll();
      }
    }

    if (changes['setBaseAmount'] !== undefined) {
      if (changes['setBaseAmount'].currentValue) {
        // console.log('RACE:onchanges:setBaseAmount:1:', this.setBaseAmount);
        // console.log('RACE:onchanges:setBaseAmount:2:', changes['setBaseAmount']?.currentValue);
        // console.log('exe 1');
        this.baseAmount = this.setBaseAmount;
        if (this.isShowBetPreview) {
          // this.showBet(true);

          if (this.selectedModifier.toLowerCase() === 'dutchcost')
            this.buildDutchWager();

          if (this.selectedModifier.toLowerCase() === 'abc')
            this.buildAbcWager();

          this.showBet(true);
        }
      }
      else {
        this.clearCustomState();
      }
    }
    // else {
    //   if (this.checkExotic()) return;
    //   // this.clearCustomState();
    // }

    // if (changes['selectedEvent'] !== undefined)
    //   if (changes['selectedEvent'].currentValue)
    //     if (this.countryStateList)
    //       this.checkWageringJurisdiction(this.selectedEvent?.ToteResponse?.EventDetail?.EventId);

    if (
      changes['selectedRace'] !== undefined &&
      changes['selectedRace'].currentValue !== undefined
    ) {

      // if (changes['selectedRace'].currentValue) {

      //   this.storeStructureCopy = [];
      //   this.prevModifierId = '';

      //   if (
      //     !this.isExoticSelections &&
      //     !this.checkExoticInChanges() &&
      //     !this.isClearCustomState
      //   ) {
      //     this.clearCustomState();
      //   }
      // }

      if (changes['selectedRace'].currentValue && this.isClearCustomState) {
        // console.log('exe 2');
        this.storeStructureCopy = [];
        this.prevModifierId = '';
        this.clearCustomState();
        this.showCurrentInfo = changes['selectedRace'].currentValue.RaceId;

        this.nestedArrayABC = [];
        this.abcTotalAmount = 0;
      }
      // else console.log('RACE:onchanges:runner:ERROR',);

      if (this.storeStructure.length) {

        if (
          this.selectedRace.RaceStatus === 1 ||
          this.selectedRace.RaceStatus === 2 ||
          this.selectedRace.RaceStatus === 4 ||
          this.selectedEvent.ToteResponse.EventDetail.EventStatus === 'Closed'
        ) this.cantBet = true;

        setTimeout(()=>{
          this.isActiveRunners();
        }, 100);
      }

      this.dutchTicket = '';
      this.dutchROI = '';
      // this.abcTotalAmount = 0;
      this.dutchAbcErrorMsg = '';
    }

    if (changes['selectedPool'] !== undefined) {

      if (changes['selectedPool'].currentValue) {

        this.storeStructureCopy = [];

        // for abc
        this.nestedArrayABC = [];
        if (this.selectedModifier.toLowerCase() === 'abc') {
          if (this.dblPkArray) {
            this.generateNestedArrayPKDbl(
              this.dblPkArray,
              this.convertLegRange(
                this.selectedPool?.Legs,
                this.selectedPool?.PoolId,
                this.selectedModifier
              ).length || 0,
              false
            );
          }
          else {
            this.generateNestedArray(
              this.selectedRace?.Runners,
              this.convertLegRange(
                this.selectedPool?.Legs,
                this.selectedPool?.PoolId,
                this.selectedModifier
              ).length || 0,
              false
            );
          }
        }

        if (changes['selectedPool'].previousValue !== undefined) {
          this.prevPoolId = changes['selectedPool'].previousValue?.PoolId;
          if (
            this.checkExotic(
              changes['selectedPool'].previousValue?.PoolId,
              '',
              '',
              false
            )
          ) {
            this.setShowCurrentInfoByRace();
            return;
          }
        }

        this.clearCustomState();

        this.setShowCurrentInfoByRace();

        // if (this.dblPkArray) {
        //   this.showCurrentInfo = this.dblPkArray[0].RaceId;

        //   setTimeout(()=>{
        //     const spanLegs = this.elementRef.nativeElement.querySelectorAll(
        //       '.waging-section .mode-place-races .head-bet #race'
        //     );
        //     spanLegs.forEach((leg: HTMLElement, index: number) => {
        //       if (index === 0) {
        //         leg?.classList.add('active');
        //         return;
        //       }
        //     });
        //   }, 50);

        // }
      }

      this.dutchTicket = '';
      this.dutchROI = '';
      this.abcTotalAmount = 0;
      this.dutchAbcErrorMsg = '';
    }

    if (changes['selectedModifier'] !== undefined) {
      if (
        changes['selectedModifier'].currentValue ||
        changes['selectedModifier'].currentValue === ''
      ) {
        // if (changes['selectedModifier'].previousValue !== undefined)
        this.prevModifierId = changes['selectedModifier'].currentValue;
        if (
          this.checkExotic(
            this.selectedPool?.PoolId,
            changes['selectedModifier'].previousValue,
            changes['selectedModifier'].currentValue,
            true
          ) &&
          this.selectedModifier.toLowerCase() !== 'dutchcost' &&
          this.selectedModifier.toLowerCase() !== 'abc'
        ) return;

        this.clearCustomState();

        // for abc
        this.nestedArrayABC = [];
        if (this.selectedModifier.toLowerCase() === 'abc') {
          if (this.dblPkArray) {
            this.generateNestedArrayPKDbl(
              this.dblPkArray,
              this.convertLegRange(
                this.selectedPool?.Legs,
                this.selectedPool?.PoolId,
                this.selectedModifier
              ).length || 0,
              false
            );
          }
          else {
            this.generateNestedArray(
              this.selectedRace?.Runners,
              this.convertLegRange(
                this.selectedPool?.Legs,
                this.selectedPool?.PoolId,
                this.selectedModifier
              ).length || 0,
              false
            );
          }
        }
      }

      this.dutchTicket = '';
      this.dutchROI = '';
      this.abcTotalAmount = 0;
      this.dutchAbcErrorMsg = '';
    }
  }

  ngAfterViewChecked(): void {
    this.setRunnerScroll();

    if (this.selectedPool !== undefined) {
      const startsWithPK = /^PK/.test(this.selectedPool.PoolId || '');
      const wordWithPK = /^PICK|Pick|pick/.test(this.selectedPool.PoolName || '');
      if (
        this.selectedPool.PoolId === 'GSL' ||
        this.selectedPool.PoolId === 'DBL' ||
        startsWithPK || wordWithPK
      ) {
        setTimeout(()=>{
          const customHeight = this.elementRef.nativeElement.querySelectorAll(
            `.custom-height`
          );
          // console.log(customHeight);
          if (customHeight.length) {
            return;
          }

          const spanLegs = this.elementRef.nativeElement.querySelectorAll(
            '.waging-section .mode-place-races .head-bet #race'
          );
          // spanLegs.forEach((leg: HTMLElement) => {
          //   leg?.classList.remove('active');
          // });
          spanLegs.forEach((leg: HTMLElement, index: number) => {
            if (index === 0) {
              leg?.classList.add('active');
              return;
            }
          });

          this.setDynamicLegHeight();
        }, 10);
      }
    }

  }

  observerLogout(): void {
    this.authFacade.isLogoutSuccess$().subscribe((isLogout?: boolean) => {
      if (isLogout) {
        this.modalCtrl?.dismiss();
        this.modal?.dismiss();

        this.alertCtrl?.dismiss();
        this.showAlertInfoHandler?.dismiss();
        this.isRequireConfirmActiveHandler?.dismiss();
        this.showAlertGeoLocationHandler?.dismiss();
        this.showAlertWagerLimitHandler?.dismiss();
        this.showAlertErrorHandler?.dismiss();
      }
    });
  }

  observerGetRaceMatrix(): void {
    this.wagerFacade.getRaceMatrix$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((matrix?: ISelectedRaceMatrix) => {
        if (_.isEmpty(matrix)) return;

        try {
          this.matrix = matrix?.['WIN']?.response?.ToteResponse;
          if (this.selectedModifier.toLowerCase() === 'dutchcost')
            this.buildDutchWager();
        } catch (error) {
          null
        }

        this.cdRef.markForCheck();
      });
  }

  checkExotic(
    prevPoolId?: string,
    prevModifierId?: string,
    modifierId?: string,
    modifier?: boolean
  ): boolean {
    // const startsWithPK = /^PK/.test(this.selectedPool?.PoolId || '');
    // const prevStartsWithPK = /^PK/.test(prevPoolId || '');
    if (
      this.isExoticSelections &&
      (
        // this.selectedPool?.PoolId === 'EX' ||
        // this.selectedPool?.PoolId === 'TRI' ||
        // this.selectedPool?.PoolId === 'SPR' ||
        // this.selectedPool?.PoolId === 'PEN' ||
        // this.selectedPool?.PoolId === 'HEX' ||
        // this.selectedPool?.PoolId === 'DBL' ||
        this.PoolIds.includes(this.selectedPool?.PoolId)
        // ||
        // startsWithPK
      ) &&
      (
        // prevPoolId === 'EX' ||
        // prevPoolId === 'TRI' ||
        // prevPoolId === 'SPR' ||
        // prevPoolId === 'PEN' ||
        // prevPoolId === 'HEX' ||
        // prevPoolId === 'DBL' ||
        this.PoolIds.includes(prevPoolId || '')
        // ||
        // prevStartsWithPK
      )
    ) {

      // if (
      //   this.vertical.includes(this.selectedPool?.PoolId) &&
      //   (this.prevPoolId === 'DBL' || prevStartsWithPK)
      // ) this.storeStructure = [];

      // if (
      //   (this.horizontal.includes(this.selectedPool?.PoolId) || startsWithPK) &&
      //   this.vertical.includes(this.prevPoolId)
      // ) this.storeStructure = [];

      if (this.currentRunners !== undefined) {
        setTimeout(()=>{
          if (modifier)
            this.onLegTypeChangeModifier(prevModifierId, modifierId, this.selectedPool?.PoolId);
          // else if (this.selectedPool?.PoolId === 'DBL' || startsWithPK)
          //   this.onLegTypeChangeDblPK();
          else
            this.onLegTypeChange(this.selectedPool?.PoolId, prevModifierId);

          // if (this.selectedModifier === '' && this.storeStructureCopy.length) {
          //   this.clearLegRoundSelector();
          //   const storeStructureCopy = _.cloneDeep(this.storeStructureCopy);
          //   this.storeStructure = storeStructureCopy;
          // }

          this.isActiveRunners();
          this.reCheckRemoveUnuseLegs();
          this.betRunnersStringFormat();
          this.showBet(true);
        }, 100);
      }

      return true;
    }
    else return false;
  }

  checkExoticInChanges(): boolean {
    // const startsWithPK = /^PK/.test(this.selectedPool?.PoolId || '');
    if (
      (
        // this.selectedPool?.PoolId === 'EX' ||
        // this.selectedPool?.PoolId === 'TRI' ||
        // this.selectedPool?.PoolId === 'SPR' ||
        // this.selectedPool?.PoolId === 'PEN' ||
        // this.selectedPool?.PoolId === 'HEX' ||
        // this.selectedPool?.PoolId === 'DBL' ||
        this.PoolIds.includes(this.selectedPool?.PoolId)
        // ||
        // startsWithPK
      )
    ) {
      return true;
    }
    else return false;
  }

  clearCustomState(): void {
    this.storeStructure = [];
    this.clearActiveAllLeg();
    this.showBet();
  }

  clearActiveAllLeg(): void {
    const divLegs = this.elementRef.nativeElement.querySelectorAll(`.mode-place-races span.mode`);
    divLegs.forEach((leg: HTMLElement) => {
      leg?.classList.remove('active');
    });
  }

  clearLegRoundSelector(): void {
    const divLegs = this.elementRef.nativeElement.querySelectorAll('.table-bet [class^="runner"]');
    // const divLegs = this.elementRef.nativeElement.querySelectorAll('.table-bet [class^="leg"]');
    divLegs.forEach((leg: HTMLElement) => {
      if (leg?.classList.contains('active') || leg?.classList.contains('couple-entry'))
        leg?.classList.remove('active');
        leg?.classList.remove('couple-entry');
        leg.innerHTML = '';
    });
  }

  findABCValue(
    legId: number,
    runnerId: number,
    nestedArrayABC: any[][]
  ): string {

    const allRunners = _.flatMapDeep(nestedArrayABC);

    const legObject: {
      legId: number;
      runnerId: number;
      value: string;
    } | any = _.find(allRunners, { legId, runnerId });

    if (!legObject) {
      // console.log(`No data found for legId ${legId} and runnerId ${runnerId}`);
      return '';
    }

    return legObject.value || '';
  }

  setABCValue(
    legId: number,
    runnerId: number,
    nestedArrayABC: any[][],
    newValue: string
  ): boolean {

    const allRunners = _.flatMapDeep(nestedArrayABC);

    const legObject: {
      legId: number;
      runnerId: number;
      value: string;
    } | any = _.find(allRunners, { legId, runnerId });

    if (!legObject) {
      // console.log(`No data found for legId ${legId} and runnerId ${runnerId}`);
      return false;
    }

    legObject.value = newValue;
    return true;
  }

  // PoolId: EX, TRI, SPR
  isActiveRunners() {
    _.forEach(this.storeStructure, (item) => {

      let runnersCoupleEntryElementLength = 0;
      const legElement = this.elementRef.nativeElement.querySelector(`.leg-${item.leg}`);
      const runnersElement = this.elementRef.nativeElement.querySelectorAll(
        `.content-bet .leg-` + item.leg
      );

      if (legElement) {
        _.forEach(item.runners, (runnerId) => {

          const runnerElement = this.elementRef.nativeElement.querySelector(
            `.runner-${runnerId}.` + legElement.classList[1]
          );

          const runnersCoupleEntryElement = this.elementRef.nativeElement.querySelectorAll(
            `.runner-${runnerId}.` + legElement.classList[1] + `.sub-couple-entry`
          );

          if (runnerElement) {
            this.renderer.addClass(runnerElement, 'active');
            // runnerElement.innerHTML = runnerId;
            runnerElement.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            // this.nestedArrayABC[Number(item.leg)-1 || 0][Number(runnerId)-1 || 0].value
            this.findABCValue(Number(item.leg), Number(runnerId), this.nestedArrayABC)
              :
            runnerId;
          }

          if (runnersCoupleEntryElement.length) {
            runnersCoupleEntryElementLength = runnersCoupleEntryElement.length;
            _.forEach(runnersCoupleEntryElement, (i) => {
              this.renderer.addClass(i, 'couple-entry');
              // i.innerHTML = runnerId + i.getAttribute(
              //   'data-entry-id'
              // );
              runnerElement.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
              // this.nestedArrayABC[Number(item.leg)-1 || 0][Number(runnerId)-1 || 0].value
              this.findABCValue(Number(item.leg), Number(runnerId), this.nestedArrayABC)
                :
              runnerId + i.getAttribute('data-entry-id');

            });
          }

        });
      }

      if ((runnersElement.length - runnersCoupleEntryElementLength) === item.runners.length) {
        const legAll = this.elementRef.nativeElement.querySelector(
          `.selector-leg-all-` + item.leg
        );
        this.renderer.addClass(legAll, 'active');
      }

    });
  }

  onLegTypeChange(poolId: string, prevModifierId?: string): void {
    if (!poolId) return;

    switch (poolId) {
      case 'EX':
      case 'QU':
      case 'OMN':
        this.updateLegs(2, prevModifierId);
        break;
      case 'TRL':
      case 'TRI':
        this.updateLegs(3, prevModifierId);
        break;
      case 'SPR':
        this.updateLegs(4, prevModifierId);
        break;
      case 'PEN':
        this.updateLegs(5, prevModifierId);
        break;
      case 'HEX':
        this.updateLegs(6, prevModifierId);
        break;
      default:
        break;
    }

    const storeStructureCopy = _.cloneDeep(this.storeStructure);
    this.storeStructureCopy = storeStructureCopy;
  }

  onLegTypeChangeModifier(prevModifierId?: string, modifierId?: string, poolId?: string): void {

    this.clearLegRoundSelector();
    const storeStructureCopy = _.cloneDeep(this.storeStructureCopy);

    switch (modifierId) {
      case 'BX':
        // 1 leg to show
        this.storeStructure = _.slice(storeStructureCopy, 0, 1);
        break;
      case '':
      case 'KB':
      case 'PB':
        // any legs to show
        this.storeStructure = storeStructureCopy;
        break;
      case 'KW':
        // 2 legs to show
        this.storeStructure = _.slice(storeStructureCopy, 0, 2);
        break;
      default:
        break;
    }

    // // Straight
    // if (modifierId === '') {

    //   this.storeStructure = this.storeStructureCopy;
    //   return;

    //   switch (poolId) {
    //     case 'EX':
    //       this.updateLegs(2, prevModifierId);
    //       break;
    //     case 'TRI':
    //       this.updateLegs(3, prevModifierId);
    //       break;
    //     case 'SPR':
    //       this.updateLegs(4, prevModifierId);
    //       break;
    //     case 'PEN':
    //       this.updateLegs(5, prevModifierId);
    //       break;
    //     case 'HEX':
    //       this.updateLegs(6, prevModifierId);
    //       break;
    //     default:
    //       break;
    //   }
    // }
    // else {

    //   let legs = 0;
    //   if (poolId === 'EX')
    //     legs = 2;
    //   if (poolId === 'TRI')
    //     legs = 3;
    //   if (poolId === 'SPR')
    //     legs = 4;
    //   if (poolId === 'PEN')
    //     legs = 5;
    //   if (poolId === 'HEX')
    //     legs = 6;

    //   switch (modifierId) {
    //     case 'BX':
    //       this.updateLegs(1, prevModifierId);
    //       break;
    //     case 'KB':
    //     case 'PB':
    //       this.updateLegs(legs, prevModifierId);
    //       break;
    //     case 'KW':
    //       this.updateLegs(2, prevModifierId);
    //       break;
    //     default:
    //       break;
    //   }
    // }
  }

  onLegTypeChangeDblPK(): void {
    if (this.selectedPool?.PoolId === 'DBL')
      this.updateLegs(2);
    else
      this.updateLegs(this.extractNumber(this.selectedPool?.PoolId));
  }

  updateLegs(requiredLegs: number, prevModifierId?: string): void {
    const currentLegs = this.storeStructure.length;
    const legElements = this.elementRef.nativeElement.querySelectorAll(
      '.mode-place-races > .head-bet span[class^="mode selector-leg-all-"]'
    );

    if (!legElements || legElements.length === 0) return;

    const lastLeg = _.cloneDeep(_.last(this.storeStructure));

    // prevModifierId === 'BX'
    if (this.prevModifierId === 'BX') {
      this.addNewLegs(currentLegs, requiredLegs, lastLeg);
      return;
    }

    if (!lastLeg || lastLeg.leg === 1) {
      return;
    }

    if (currentLegs < requiredLegs) {
      this.addNewLegs(currentLegs, requiredLegs, lastLeg);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addNewLegs(currentLegs: number, requiredLegs: number, lastLeg: any): void {
    for (let i = currentLegs; i < requiredLegs; i++) {

      const newLeg = _.cloneDeep(lastLeg);

      if (!newLeg) return;
        newLeg.leg = i + 1;

      // if does not exist proceed
      if (!_.some(this.storeStructure, { leg: newLeg.leg })) {
        // add
        this.storeStructure.push(newLeg);
      }
    }
  }

  reCheckRemoveUnuseLegs(): void {
    const toBeFiltered: number[] = [];
    let hasActiveSelector = false;

    const legElement = this.elementRef.nativeElement.querySelectorAll(
      '.mode-place-races > .head-bet span[class^="mode selector-leg-all-"]'
    );

    _.forEach(legElement, (item) => {

        const legId = this.renderer.selectRootElement(item, true).id;
        const runnersElement = this.elementRef.nativeElement.querySelectorAll(
          `.content-bet .leg-` + legId
        );

        _.forEach(runnersElement, (item) => {
          if (item.classList[2] !== undefined && item.classList[2] === 'active') {
            hasActiveSelector = true;
          }
        });

        if (hasActiveSelector) {
          toBeFiltered.push(Number(legId));
          hasActiveSelector = false;
        }

    });

    this.storeStructure = _.filter(this.storeStructure, (leg) => toBeFiltered.includes(leg.leg));
  }

  // updateLegs(requiredLegs: number): void {
  //   const currentLegs = this.storeStructure.length;

  //   if (currentLegs < requiredLegs) {

  //     const lastLeg = _.cloneDeep(_.last(this.storeStructure));
  //     for (let i = currentLegs; i < requiredLegs; i++) {
  //       const newLeg = _.cloneDeep(lastLeg);

  //       if (!newLeg) return;

  //       newLeg.leg = i + 1;
  //       this.storeStructure.push(newLeg);
  //     }
  //   }
  //   else if (currentLegs > requiredLegs) {

  //     this.storeStructure = _.slice(this.storeStructure, 0, requiredLegs);
  //   }
  // }

  setRunnerScroll(): void {
    if (!this.selectedRace?.Runners?.[0]?.Entries) return;

    if (this.setRunnerScrollTimeout) clearTimeout(this.setRunnerScrollTimeout);
    this.setRunnerScrollTimeout = setTimeout(() => {
      if (this.runnerRef?.nativeElement) {

        const headerSectionHeight = (document.querySelector(".header-section") as any)?.offsetHeight;
        const eventtrackSelectionSectionHeight = (document.querySelector(".eventtrack-selection-section") as any)?.offsetHeight;
        const raceSectionHeight = (document.querySelector(".race-section") as any)?.offsetHeight;
        const raceSelectionSectionHeight = (document.querySelector(".race-selection-section") as any)?.offsetHeight;
        const appSectionHeight = (document.querySelector(".app-section") as any)?.offsetHeight;
        const footerContentHeight = (document.querySelector(".footer-content") as any)?.offsetHeight;
        const closeRaceSectionHeight = (document.querySelector(".close-race-section") as any)?.offsetHeight || 0;

        const liveVideoSectionHeight = (document.querySelector(".live-video-section") as any)?.offsetHeight || 0;

        if (this.triggerSetRunnerHeight) {
          this.renderer.setStyle(
            this.runnerRef?.nativeElement,
            'height',
            String(
              appSectionHeight-
              (headerSectionHeight+liveVideoSectionHeight)-
              footerContentHeight-closeRaceSectionHeight-52
            )+'px'
          );
        }
        else {
          this.renderer.setStyle(
            this.runnerRef?.nativeElement,
            'height',
            String(
              appSectionHeight-
              (headerSectionHeight+eventtrackSelectionSectionHeight+raceSectionHeight+raceSelectionSectionHeight)-
              footerContentHeight-closeRaceSectionHeight-48
            )+'px'
          );
        }

      }
    }, 300);
  }

  setDynamicLegHeight(): void {
    const runnersInfoHeightArr: any[] = [];
    this.runnersInfo.forEach((item, index) => {
      runnersInfoHeightArr.push(item.nativeElement.offsetHeight);
    });

    let i = 0;
    this.legsInfo.forEach((item, index) => {

      // const iChildBet = item.nativeElement.querySelector('.bet-content i');
      // const currentRace = _.find(this.dblPkArray, { RaceId: Number(iChildBet.id) });

      // if (Number(iChildBet.classList[1].split('-')[1]) > currentRace.Runners.length) {
      if ((i+1) > runnersInfoHeightArr.length) {
        i = 0;
      }

      // console.log(i + ' counter dri');

      // console.log(`Element ${index}:`, item.nativeElement);
      // console.log(`Element ${index}:`, item.nativeElement.offsetHeight);
      // console.log(runnersInfoHeightArr[i]);
      // console.log(i);

      // item.nativeElement.style.height = runnersInfoHeightArr[i] + 'px';
      // item.nativeElement.classList.add('custom-height');

      // #legsInfo
      // const childBet = item.nativeElement.querySelector('.bet-content');
      // const iChild = item.nativeElement.querySelector('.bet-content i');

      // if (childBet) {
      //   item.nativeElement.style.height = runnersInfoHeightArr[i] + 'px';
      // }

      // if (childBet) {
          item.nativeElement.closest('.bet').classList.add('custom-height');
          // item.nativeElement.closest('.bet').style.height = 'auto !Important';
          // item.nativeElement.closest('.bet').style.height = runnersInfoHeightArr[i] + 'px';
          item.nativeElement.style.height = runnersInfoHeightArr[i] + 'px';
      // }

      i++;
    });
  }

  onScrollHideBetPreview(): void {
    const betSection = this.elementRef.nativeElement.querySelector('.bet-footer-section');
    if (betSection.classList.contains('active')) {
      betSection.classList.remove('active');
      this.commonFacade.setIsShowFooter(true);
    }
  }

  showCurrentInfoByRace($event: any, raceId: number): void {
    if (!raceId) return;

    this.showCurrentInfo = raceId;

    // setTimeout(()=>{
    //   this.setDynamicLegHeight();
    // }, 100);

    const spanLegs = this.elementRef.nativeElement.querySelectorAll(
      '.waging-section .mode-place-races .head-bet #race'
    );
    spanLegs.forEach((leg: HTMLElement) => {
      leg?.classList.remove('active');
    });
    const race = $event.target as HTMLElement;
    race.classList.add('active');
  }

  setShowCurrentInfoByRace(): void {
    if (this.dblPkArray) {
      this.showCurrentInfo = this.dblPkArray[0].RaceId;

      setTimeout(()=>{
        const spanLegs = this.elementRef.nativeElement.querySelectorAll(
          '.waging-section .mode-place-races .head-bet #race'
        );
        spanLegs.forEach((leg: HTMLElement, index: number) => {
          if (index === 0) {
            leg?.classList.add('active');
            return;
          }
        });
      }, 50);

    }
  }

  async showRunnerInfo(event: Event, runnerInfo: any) {
    const popover = await this.popoverController.create({
      component: ShowRunnerInfoComponent,
      componentProps: { content: runnerInfo },
      event: event,
      translucent: true
    });
    await popover.present();
  }

  checkPool(poolId: string): boolean {

    let horizontalWager = false;
    switch (poolId) {
      case 'DBL':
      case 'PK3':
      case 'PK4':
      case 'PK5':
      case 'PK6':
      case 'PK7':
      case 'PK8':
      case 'PK9':
      case 'PK10':
      case 'P11':
      case 'PK11':
      case 'P12':
      case 'PK12':
        horizontalWager = true;
      break;
    }

    return horizontalWager;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  betAllRace($event: any, legId: number): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:betAllRace', false);
    }

    // if (!this.hasPermission() || !leg) return;
    if (!legId) return;

    if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
      this.router.navigate(['login']);

      return;
    }

    // const betAll = $event.target as HTMLElement;

    // if (betAll.classList.contains('active')) {
    //   betAll.classList.remove('active');

    //   this.removeLegByNumber(Number(betAll?.id));

    //   const divLegs = this.elementRef.nativeElement.querySelectorAll(`.leg-${leg}`);
    //   divLegs.forEach((leg: HTMLElement) => {
    //     leg?.classList.remove('active');
    //     leg.innerHTML = '';
    //   });
    // }
    // else {
    //   betAll.classList.add('active');

    //   const divLegs = this.elementRef.nativeElement.querySelectorAll(`.leg-${leg}`);
    //   divLegs.forEach((leg: HTMLElement) => {
    //     leg?.classList.add('active');
    //     if (leg?.classList.length > 1) {
    //       const runnerId = leg.classList[1].split('-');
    //       leg.innerHTML = runnerId[1];
    //     }
    //   });

    // }

    const betAll = $event.target as HTMLElement;

    if (betAll.classList.contains('active')) {
      betAll.classList.remove('active');

      this.removeLegByNumber(Number(betAll?.id));

      const divLegs = this.elementRef.nativeElement.querySelectorAll(`.leg-${legId}`);
      divLegs.forEach((leg: HTMLElement) => {
        leg?.classList.remove('active');
        leg?.classList.remove('couple-entry');
        leg.innerHTML = '';
      });

      // init abc cycle
      this.nestedArrayABC = [];
      if (this.selectedModifier.toLowerCase() === 'abc') {
        if (this.dblPkArray) {
          this.generateNestedArrayPKDbl(
            this.dblPkArray,
            this.convertLegRange(
              this.selectedPool?.Legs,
              this.selectedPool?.PoolId,
              this.selectedModifier
            ).length || 0,
            false
          );
        }
        else {
          this.generateNestedArray(
            this.selectedRace?.Runners,
            this.convertLegRange(
              this.selectedPool?.Legs,
              this.selectedPool?.PoolId,
              this.selectedModifier
            ).length || 0,
            false
          );
        }
      }

    }
    else {
      betAll.classList.add('active');
      let i = 0;

      // init abc cycle
      this.nestedArrayABC = [];
      if (this.selectedModifier.toLowerCase() === 'abc') {
        if (this.dblPkArray) {
          this.generateNestedArrayPKDbl(
            this.dblPkArray,
            this.convertLegRange(
              this.selectedPool?.Legs,
              this.selectedPool?.PoolId,
              this.selectedModifier
            ).length || 0,
            true
          );
        }
        else {
          this.generateNestedArray(
            this.selectedRace?.Runners,
            this.convertLegRange(
              this.selectedPool?.Legs,
              this.selectedPool?.PoolId,
              this.selectedModifier
            ).length || 0,
            true
          );
        }
      }

      const divLegs = this.elementRef.nativeElement.querySelectorAll(`.leg-${legId}`);
      divLegs.forEach((leg: HTMLElement) => {
        // leg?.classList.add('active');
        // if (leg?.classList.length > 1) {
        //   const runnerId = leg.classList[1].split('-');
        //   leg.innerHTML = runnerId[1];
        // }

        if (!leg?.classList.contains('sub-couple-entry')) {
          leg?.classList.add('active');
          if (leg?.classList.length > 1) {
            const runnerId = leg?.classList[0].split('-');
            // leg.innerHTML = runnerId[1];
            leg.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.findABCValue(Number(legId), Number(runnerId[1]), this.nestedArrayABC)
            // this.nestedArrayABC[Number(runnerId[1])-1 || 0][Number(legId)-1 || 0].value
              :
            runnerId[1];
          }
        }
        else if (i === 0 && leg?.classList.contains('sub-couple-entry')) {
          leg?.classList.add('active');
          // leg?.classList.add('couple-entry');
          const runnerId = leg?.classList[0].split('-');
          // leg.innerHTML = runnerId[1]+leg?.getAttribute('data-entry-id');
          leg.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
          this.findABCValue(Number(legId), Number(runnerId[1]), this.nestedArrayABC)
          // this.nestedArrayABC[Number(runnerId[1])-1 || 0][Number(legId)-1 || 0].value
            :
          runnerId[1]+leg?.getAttribute('data-entry-id');
        }
        // else if (leg?.classList.contains('couple-entry')) {
        //   leg?.classList.remove('couple-entry');
        //   leg.innerHTML = '';
        // }
        else if (i > 0) {
          if (leg) {
            leg?.classList.add('couple-entry');
            const runnerId = leg?.classList[0].split('-');
            // leg.innerHTML = runnerId[1]+leg?.getAttribute('data-entry-id');
            leg.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.findABCValue(Number(legId), Number(runnerId[1]), this.nestedArrayABC)
            // this.nestedArrayABC[Number(runnerId[1])-1 || 0][Number(legId)-1 || 0].value
              :
            runnerId[1]+leg?.getAttribute('data-entry-id');
          }
        }
        else {
          if (leg) {
            leg?.classList.add('active');
            const runnerId = leg?.classList[0].split('-');
            // leg.innerHTML = runnerId.toString();
            leg.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.findABCValue(Number(legId), Number(runnerId[1]), this.nestedArrayABC)
            // this.nestedArrayABC[Number(runnerId[1])-1 || 0][Number(legId)-1 || 0].value
              :
            runnerId.toString();
          }
        }
        i++;
      });

    }

    this.betRunnersStringFormat();

    // exotic must be stored
    if(
      this.isExoticSelections &&
      this.PoolIds.includes(this.selectedPool?.PoolId)
    ) {
      const storeStructureCopy = _.cloneDeep(this.storeStructure);
      this.storeStructureCopy = storeStructureCopy;
    }

    // this.sumSelectedLegs();
    this.showBet(true);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  betRace($event: any, poolId: string, roundId?: number, raceId?: number, legId?: number): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:betRace', false);
    }

    // if (!this.hasPermission() || !roundId) return;
    if (!roundId) return;

    if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
      this.router.navigate(['login']);

      return;
    }

    // const bet = ($event.target as HTMLElement).classList;
    // const bet = $event.target as HTMLElement;
    // if (bet.classList.contains('active')) {
    //   bet.classList.remove('active');
    //   bet.innerHTML = '';

    //   this.removeRunnerFromLegByValue(Number(bet?.id), Number(bet?.classList[1].split('-')[1]));

    //   const legIndex = this.storeStructure.findIndex(item => item.leg === Number(bet?.id));
    //   if (legIndex !== -1) {
    //     this.storeStructure.splice(legIndex, 1);
    //   }
    // }
    // else {
    //   bet.classList.add('active');
    //   bet.innerHTML = roundId.toString();
    // }

    if (raceId) {
      this.showCurrentInfo = raceId;

      const spanLegs = this.elementRef.nativeElement.querySelectorAll(
        '.waging-section .mode-place-races .head-bet #race'
      );
      spanLegs.forEach((leg: HTMLElement) => {
        leg?.classList.remove('active');

        if (leg.innerHTML.replace(/\s+/g, '') == 'R'+raceId) {
          leg.classList.add('active');
        }
      });
    }

    const bet = $event.target as HTMLElement;

    if (!this.checkPool(poolId)) {

      let i = 0;
      let betSelector = '';
      bet.classList.forEach((item, index) => {
        // if (betSelector && index < 2) betSelector = betSelector + ' ';
        if (index < 2 ) {
          betSelector = betSelector + '.' + item;
        }
      });

      const mutipleBetSelected = this.elementRef.nativeElement.querySelectorAll(
        '.table-bet i' + betSelector
      );
      mutipleBetSelected.forEach((betElem: HTMLElement) => {

        if (
          betElem?.classList.contains('active') &&
          !betElem?.classList.contains('couple-entry')
        ) {

          // abc
          if (
            this.selectedModifier.toLowerCase() === 'abc' &&
            this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC) !== ''
            // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value !== ''
          ) {
            // nothing
          }
          else {
            betElem?.classList.remove('active');
            betElem.innerHTML = '';

            this.removeRunnerFromLegByValue(
              Number(bet?.id),
              Number(bet?.classList[1].split('-')[1])
            );

            const legIndex = this.storeStructure.findIndex(item => item.leg === Number(bet?.id));
            if (legIndex !== -1) {
              this.storeStructure.splice(legIndex, 1);
            }
          }

        }
        else if (i === 0 && betElem?.classList.contains('sub-couple-entry')) {
          betElem?.classList.add('active');
          // leg?.classList.add('couple-entry');
          const runnerId = betElem?.classList[0].split('-');
          // betElem.innerHTML = runnerId[1]+betElem?.getAttribute('data-entry-id');
          betElem.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
          this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
          // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value
            :
          runnerId[1]+betElem?.getAttribute('data-entry-id');
        }
        else if (betElem?.classList.contains('couple-entry')) {

          // abc
          if (
            this.selectedModifier.toLowerCase() === 'abc' &&
            this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC) !== ''
            // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value !== ''
          ) {
            // nothing
          }
          else {
            betElem?.classList.remove('couple-entry');
            betElem.innerHTML = '';
          }
        }
        else if (i > 0) {
          if (betElem) {
            betElem?.classList.add('couple-entry');
            // betElem.innerHTML = roundId.toString()+betElem?.getAttribute('data-entry-id');
            betElem.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
            // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value
              :
            roundId.toString()+betElem?.getAttribute('data-entry-id');
          }
        }
        else {
          if (betElem) {
            betElem?.classList.add('active');
            // betElem.innerHTML = roundId.toString();
            betElem.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
            // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value
              :
            roundId.toString();
          }
        }
        i++;
      });

    }
    else {

      const grandParentElement = bet.parentElement?.parentElement;

      if (grandParentElement) {
        let i = 0;
        let iTagCount = 0;

        for (const child of Array.from(grandParentElement.children)) {
          const firstChild = child.firstElementChild;
          if (firstChild?.tagName.toLowerCase() === 'i') {
            iTagCount++;
          }
        }

        for (const child of Array.from(grandParentElement.children)) {

          const firstChild = child.firstElementChild;

          if (
            firstChild?.classList.contains('active') &&
            firstChild?.tagName.toLowerCase() === 'i' &&
            !firstChild?.classList.contains('couple-entry')
          ) {

            // abc
            if (
              this.selectedModifier.toLowerCase() === 'abc' &&
              this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC) !== ''
              // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value !== ''
            ) {
              // nothing
            }
            else {
              firstChild?.classList.remove('active');
              firstChild.innerHTML = '';

              this.removeRunnerFromLegByValue(
                Number(bet?.id),
                Number(bet?.classList[1].split('-')[1])
              );

              const legIndex = this.storeStructure.findIndex(item => item.leg === Number(bet?.id));
              if (legIndex !== -1) {
                this.storeStructure.splice(legIndex, 1);
              }
            }
          }
          // iTagCount === 1
          else if (
            Number(firstChild?.getAttribute('data-index-is')) === 1 &&
            firstChild?.classList.contains('sub-couple-entry')
          ) {
            firstChild?.classList.add('active');
            const runnerId = firstChild?.classList[0].split('-');
            // firstChild.innerHTML = runnerId[1]+firstChild?.getAttribute('data-entry-id');
            firstChild.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
            this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
            // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value
              :
            runnerId[1]+firstChild?.getAttribute('data-entry-id');
          }
          else if (firstChild?.classList.contains('couple-entry')) {

            // abc
            if (
              this.selectedModifier.toLowerCase() === 'abc' &&
              this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC) !== ''
              // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value !== ''
            ) {
              // nothing
            }
            else {
              firstChild?.classList.remove('couple-entry');
              firstChild?.classList.remove('active');
              firstChild.innerHTML = '';
            }
          }
          else if (i > 0) {
            if (firstChild?.tagName.toLowerCase() === 'i') {
              firstChild?.classList.add('couple-entry');
              // firstChild.innerHTML = roundId.toString()+
              // firstChild?.getAttribute('data-entry-id');
              firstChild.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
              this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
              // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value
                :
              firstChild.innerHTML = roundId.toString()+
              firstChild?.getAttribute('data-entry-id');
            }
          }
          else {
            if (firstChild?.tagName.toLowerCase() === 'i') {
              firstChild?.classList.add('active');
              // firstChild.innerHTML = roundId.toString();
              firstChild.innerHTML = this.selectedModifier.toLowerCase() === 'abc' ?
              this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC)
              // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value
                :
              firstChild.innerHTML = roundId.toString();
            }
          }
          i++;
        }
      }
    }

    // const headBet = this.elementRef.nativeElement.querySelectorAll(
    //   '.head-bet .selector-leg-all-' + roundId
    // );

    // if ( this.checkActiveRound(roundId) === 1 ) {
    //   headBet.forEach((round: HTMLElement) => {
    //     round.classList.remove('active');
    //     return;
    //   });
    // }

    // if ( this.checkActiveRound(roundId) === 2 ) {
    //   headBet.forEach((round: HTMLElement) => {
    //     round.classList.add('active');
    //     return;
    //   });
    // }

    // abc
    if (this.selectedModifier.toLowerCase() === 'abc') {

      const currentValue = this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC);
      // const currentValue = this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value;
      const nextIndex = (this.abcArray.indexOf(currentValue) + 1) % this.abcArray.length;

      this.setABCValue(
        Number(legId),
        Number(roundId),
        this.nestedArrayABC,
        this.abcArray[
          nextIndex
        ]
      )
      // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value = this.abcArray[
      //   nextIndex
      // ];

      const divLegs = this.elementRef.nativeElement.querySelectorAll(
        '.table-bet .content-bet .runner-' + roundId + '.leg-' + legId
      );

      divLegs.forEach((leg: HTMLElement) => {
        // this.nestedArrayABC[(roundId-1) || 0][(legId ? legId-1 : 0) || 0].value
        if (this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC))
          leg.innerHTML = this.findABCValue(Number(legId), Number(roundId), this.nestedArrayABC);
        else {
          if (
            leg?.classList.contains('active') ||
            leg?.classList.contains('couple-entry')
          ) {
            leg?.classList.remove('active');
            leg?.classList.remove('couple-entry');
            leg.innerHTML = '';

            this.removeRunnerFromLegByValue(
              Number(bet?.id),
              Number(bet?.classList[1].split('-')[1])
            );

            const legIndex = this.storeStructure.findIndex(item => item.leg === Number(bet?.id));
            if (legIndex !== -1) {
              this.storeStructure.splice(legIndex, 1);
            }

          }
        }
      });
    }

    // add leg to store
    this.betRunnersStringFormat();

    // setTimeout(()=> {
    //   // add leg to store
    //   this.betRunnersStringFormat();
    // }, 500);

    // exotic must be stored
    if(
      this.isExoticSelections &&
      this.PoolIds.includes(this.selectedPool?.PoolId)
    ) {
      const storeStructureCopy = _.cloneDeep(this.storeStructure);
      this.storeStructureCopy = storeStructureCopy;
    }

    if (legId)
      this.headLegSelector(legId);

    // this.sumSelectedLegs();
    this.showBet(true);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  checkActiveRound(roundId: number): number {
    const divBets = this.elementRef.nativeElement.querySelectorAll('.content-bet .bet');
    let roundSelect = 0;
    let activeRoundSelect = 0;
    let inactiveRoundSelect = 0;

    divBets.forEach((bet: HTMLElement) => {
      // const i = bet.querySelector('.runner-' + roundId);
      const i = bet.querySelector('i.leg-' + roundId);
        if (i?.classList.contains('active')) {
          activeRoundSelect += 1;
        }
        else {
          inactiveRoundSelect += 1;
        }
    });

    if ( !activeRoundSelect && !inactiveRoundSelect ) {
      roundSelect = 0;
    }

    if ( activeRoundSelect && inactiveRoundSelect ) {
      roundSelect = 1;
    }

    if ( activeRoundSelect && !inactiveRoundSelect ) {
      roundSelect = 2;
    }

    return roundSelect;
  }

  addLeg(leg: number): void {
    this.storeStructure.push({ leg, runners: [] });
    this.storeStructure.sort((a, b) => a.leg - b.leg);
  }

  addRunnerToLeg(leg: number, runnerData: any): void {
    const legIndex = this.storeStructure.findIndex(item => item.leg === leg);
    if (legIndex !== -1) {
        const legRunners = this.storeStructure[legIndex].runners;
        if (!legRunners.includes(runnerData)) {
            legRunners.push(runnerData);
            legRunners.sort((a, b) => a - b);
        } else {
            // console.error(`Runner ${runnerData} already exists in leg ${leg}.`);
        }
    } else {
        // console.error(`Leg ${leg} not found.`);
    }
  }

  removeLegByNumber(leg: number): void {
    const legIndex = this.storeStructure.findIndex(item => item.leg === leg);
    if (legIndex !== -1) {
      this.storeStructure.splice(legIndex, 1);
    } else {
      // console.error(`Leg ${leg} not found.`);
    }
  }

  removeRunnerFromLegByValue(leg: number, runnerData: any): void {
    const legIndex = this.storeStructure.findIndex(item => item.leg === leg);
    if (legIndex !== -1) {
      const legRunners = this.storeStructure[legIndex].runners;
      const runnerIndex = legRunners.indexOf(runnerData);
      if (runnerIndex !== -1) {
        legRunners.splice(runnerIndex, 1);
      } else {
        // console.error(`Runner ${runnerData} not found in leg ${leg}.`);
      }
    } else {
      // console.error(`Leg ${leg} not found.`);
    }
  }

  betRunnersStringFormat(): void {
    // const divLegs = this.elementRef.nativeElement.querySelectorAll('.table-bet i[class^="leg"]');
    const divLegs = this.elementRef.nativeElement.querySelectorAll('.table-bet i[class^="runner"]');
    divLegs.forEach((leg: HTMLElement) => {
      if (leg?.classList.contains('active')) {
        if (this.storeStructure.length) {
          for (let i=0; i < this.storeStructure.length; i++) {
            if (!this.storeStructure.some(item => item.leg === Number(leg?.id))) {
              this.addLeg(Number(leg?.id));
            }
          }
        }
        else {
          this.addLeg(Number(leg?.id));
        }
      }
    });

    divLegs.forEach((leg: HTMLElement, index: number) => {
      if (leg?.classList.contains('active')) {
        // const currentId = leg?.innerHTML.match(/\d+/)?.[0] || '';
        const currentId = this.selectedModifier.toLowerCase() === 'abc' ?
        Number(leg.classList[0].split('-')[1] || 0)
          :
        leg?.innerHTML.match(/\d+/)?.[0] || '';
        this.addRunnerToLeg(Number(leg?.id), Number(currentId));
        // this.addRunnerToLeg(Number(leg?.id), Number(leg?.innerHTML));
      }
    });

    this.storedSelectedRunners = this.formatConsecutiveSequencesWithLegs(this.storeStructure);

    // this.betPreviewABC();

    // if (this.selectedModifier.toLowerCase() === 'abc') {
    //   if (this.setTimerABC) {
    //     clearTimeout(this.setTimerABC);
    //   }

    //   this.setTimerABC = setTimeout(() => {

    //     const startsWithPK = /^PK/.test(this.selectedPool.PoolId || '');
    //     const wordWithPK = /^PICK/.test(this.selectedPool.PoolName || '');

    //     if (
    //       this.selectedPool.PoolId === 'GSL' ||
    //       this.selectedPool.PoolId === 'DBL' ||
    //       startsWithPK || wordWithPK
    //     ) {
    //       let filteredNumbers = this.storeStructure.map(group => {
    //         return {
    //           leg: group.leg,
    //           runners: group.runners.filter(num => {
    //             const flattenedArray = this.nestedArrayABC.flat(2);
    //             const legData = flattenedArray.find(item =>
    //               item.legId === group.leg && item.runnerId === num
    //             );
    //             return legData && legData.value === 'A';
    //           })
    //         };
    //       });

    //       filteredNumbers = this.storeStructure.map(group => {
    //         const filteredGroup = filteredNumbers.find(f => f.leg === group.leg);
    //         return {
    //           leg: group.leg,
    //           runners: filteredGroup ? filteredGroup.runners : []
    //         };
    //       });

    //       filteredNumbers = _.filter(filteredNumbers, item => item.runners.length > -1);

    //       const resultSelectedRunners = this.formatConsecutiveSequencesWithLegs(filteredNumbers);
    //       this.storedSelectedRunners = _.trimEnd(resultSelectedRunners, '/');
    //       this.cdRef.markForCheck();

    //       // console.log(filteredNumbers);
    //       // console.log(this.storedSelectedRunners);
    //     }
    //     else {
    //       let filteredNumbers = this.storeStructure.map(group => {
    //         return {
    //           leg: group.leg,
    //           runners: group.runners.filter(num => {
    //             const legData = this.nestedArrayABC.find(leg => leg.some(item => {
    //               return item.legId === group.leg && item.runnerId === num;
    //             }));
    //             return legData && legData.find(
    //               item =>
    //               item.legId === group.leg &&
    //               item.runnerId === num &&
    //               item.value === 'A'
    //             );
    //           })
    //         };
    //       });

    //       filteredNumbers = _.filter(filteredNumbers, item => item.runners.length > -1);

    //       const resultSelectedRunners = this.formatConsecutiveSequencesWithLegs(filteredNumbers);
    //       this.storedSelectedRunners = _.trimEnd(resultSelectedRunners, '/');
    //       this.cdRef.markForCheck();

    //       // console.log(filteredNumbers);
    //       // console.log(this.storedSelectedRunners);
    //     }

    //   }, 400);
    // }
    // else {
    //   this.storedSelectedRunners = this.formatConsecutiveSequencesWithLegs(this.storeStructure);
    // }

  }

  betPreviewABC(): void {
    if (this.selectedModifier.toLowerCase() === 'abc') {
      if (this.setTimerABC) {
        clearTimeout(this.setTimerABC);
      }

      this.setTimerABC = setTimeout(() => {

        const startsWithPK = /^PK/.test(this.selectedPool.PoolId || '');
        const wordWithPK = /^PICK|Pick|pick/.test(this.selectedPool.PoolName || '');

        if (
          this.selectedPool.PoolId === 'GSL' ||
          this.selectedPool.PoolId === 'DBL' ||
          startsWithPK || wordWithPK
        ) {
          let filteredNumbers = this.storeStructure.map(group => {
            return {
              leg: group.leg,
              runners: group.runners.filter(num => {
                const flattenedArray = this.nestedArrayABC.flat(2);
                const legData = flattenedArray.find(item =>
                  item.legId === group.leg && item.runnerId === num
                );
                return legData && legData.value === 'A';
              })
            };
          });

          filteredNumbers = this.storeStructure.map(group => {
            const filteredGroup = filteredNumbers.find(f => f.leg === group.leg);
            return {
              leg: group.leg,
              runners: filteredGroup ? filteredGroup.runners : []
            };
          });

          filteredNumbers = _.filter(filteredNumbers, item => item.runners.length > -1);

          const resultSelectedRunners = this.formatConsecutiveSequencesWithLegs(filteredNumbers);
          this.storedSelectedRunners = _.trimEnd(resultSelectedRunners, '/');
          this.cdRef.markForCheck();

          // console.log(filteredNumbers);
          // console.log(this.storedSelectedRunners);
        }
        else {
          let filteredNumbers = this.storeStructure.map(group => {
            return {
              leg: group.leg,
              runners: group.runners.filter(num => {
                const legData = this.nestedArrayABC.find(leg => leg.some(item => {
                  return item.legId === group.leg && item.runnerId === num;
                }));
                return legData && legData.find(
                  item =>
                  item.legId === group.leg &&
                  item.runnerId === num &&
                  item.value === 'A'
                );
              })
            };
          });

          filteredNumbers = _.filter(filteredNumbers, item => item.runners.length > -1);

          const resultSelectedRunners = this.formatConsecutiveSequencesWithLegs(filteredNumbers);
          this.storedSelectedRunners = _.trimEnd(resultSelectedRunners, '/');
          this.cdRef.markForCheck();

          // console.log(filteredNumbers);
          // console.log(this.storedSelectedRunners);
        }

      }, 400);
    }
    else {
      this.storedSelectedRunners = this.formatConsecutiveSequencesWithLegs(this.storeStructure);
    }
  }

  formatConsecutiveSequencesWithLegs(data: { leg: number, runners: number[] }[]): string {
    if (data.length === 0) {
      return '';
    }

    let result = '';

    data.forEach((legData, index) => {
      const legResult = this.formatConsecutiveSequences(legData.runners);
      result += legResult;
      if (index < data.length - 1 && legResult !== '') {
        result += '/';
      }
    });
    return result;
  }

  // arr = runners data
  formatConsecutiveSequences(arr: number[]): string {
    if (arr.length === 0) {
      return '';
    }

    arr.sort((a, b) => a - b);
    let result = '';
    let consecutiveStart = arr[0];
    let consecutiveEnd = arr[0];

    for (let i = 1; i < arr.length; i++) {
      if (arr[i] === consecutiveEnd + 1) {
        consecutiveEnd = arr[i];
      } else {
        if (consecutiveEnd - consecutiveStart >= 1) {
          if (consecutiveEnd - consecutiveStart >= 2) {
            result += `${consecutiveStart}-${consecutiveEnd},`;
          } else {
            result += `${consecutiveStart},${consecutiveEnd},`;
          }
        } else {
          result += `${consecutiveStart},`;
        }
        consecutiveStart = consecutiveEnd = arr[i];
      }
    }

    if (consecutiveEnd - consecutiveStart >= 1) {
      if (consecutiveEnd - consecutiveStart >= 2) {
        result += `${consecutiveStart}-${consecutiveEnd}`;
      } else {
        result += `${consecutiveStart},${consecutiveEnd}`;
      }
    } else {
      result += `${consecutiveStart}`;
    }

    return result;
  }

  sumSelectedLegs(): void {
    this.bets = 0;
    this.runners = '';
    let index = 0;
    let tempFormatWager = '';
    let tempFormatWagerSplit = [];
    const divLegs = this.elementRef.nativeElement.querySelectorAll('.table-bet [class^="leg"]');
    divLegs.forEach((leg: HTMLElement) => {
      if (leg?.classList.contains('active')) {

        tempFormatWager += leg.innerHTML + ' ';
        if (tempFormatWager.split(' ').length > 2) {

          const tempFormatWagerArr = tempFormatWager.split(' ');

          tempFormatWager +=
            tempFormatWagerArr[0] + '-' + tempFormatWagerArr[tempFormatWagerArr.length - 1];

        } else {
          tempFormatWager += tempFormatWager.split(' ').length < 2 ?
          tempFormatWager.split(' ')[0]
          :
          tempFormatWager.split(' ')[0] + ', ' + tempFormatWager.split(' ')[1]
        }

        // runners for payload
        if (index < (divLegs.length)) {
          this.runners += leg.innerHTML + ',';
          this.bets += 1;
        }
        else {
          this.runners += leg.innerHTML;
          this.bets += 1;
        }
        // runners for payload end
      }
      else {
        tempFormatWager += leg.innerHTML + ',';
      }

      index += 1;
    });

    // console.log(divLegs);
    // console.log(this.bets);
    // console.log(this.runners);
    // console.log(tempFormatWager);
  }

  headLegSelector(legId: number): void {
    // header leg
    let z = 0;
    const stored = _.find(this.storeStructure, ['leg', legId]);

    if (stored === undefined) return;

      const legElement = this.elementRef.nativeElement.querySelector(`.leg-${legId}`);
      const legAll = this.elementRef.nativeElement.querySelector(
        `.selector-leg-all-` + legId
      );

      if (legElement) {
        const runnerElement = this.elementRef.nativeElement.querySelectorAll(
          `.content-bet .` + legElement.classList[1]
        );

        _.forEach(runnerElement, (item) => {
          z++;
        });

        if (z === stored.runners.length && legId === stored.leg) {
          z = 0;
          this.renderer.addClass(legAll, 'active');
        }
        else {
          z = 0;
          this.renderer.removeClass(legAll, 'active');
        }

      }
  }

  // headLegSelector(legId: number): void {
  //   // header leg
  //   let z = 0;
  //   _.forEach(this.storeStructure, (item) => {
  //     const legElement = this.elementRef.nativeElement.querySelector(`.leg-${item.leg}`);
  //     const legAll = this.elementRef.nativeElement.querySelector(
  //       `.selector-leg-all-` + item.leg
  //     );
  //     console.log(legAll);
  //     if (z === item.runners.length) {
  //       this.renderer.addClass(legAll, 'active');
  //     }
  //     else {
  //       this.renderer.removeClass(legAll, 'active');
  //     }

  //     if (legElement) {
  //       z = 0;
  //       _.forEach(item.runners, (runnerId) => {

  //         const runnerElement = this.elementRef.nativeElement.querySelector(
  //           `.runner-${runnerId}.` + legElement.classList[1]
  //         );

  //         if (runnerElement) {
  //           z++;
  //         }
  //       });
  //     }
  //   });
  // }

  hasPermission(): boolean {
    if (this.permissionService.isAllowed()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  betTotal(): number {
    return ((this.bets * 100) * (this.baseAmount * 100)) / 10000;
  }

  getModId(selectedModifier: string): any {
    let modId = 0; // default Straight | ABC
    switch (selectedModifier) {
      case 'BX':
        modId = 2;
      break;

      case 'KB':
        modId = 6;
      break;

      case 'PB':
        modId = 3;
      break;

      case 'KW':
        modId = 5;
      break;
    }
    return modId;
  }

  transformRunners(data: any[]): any[] {
    return _.map(data, item => {
      return {
        Auto: false,
        Runners: item.runners.join(',')
      };
    });
  }

  transformLegsRunners(data: any[]): any[] {
    return _.times(
      data.length, i => _.map(
        data[i].runners, String
      )
    );
  }

  convertAbbreToWords(abbreviation: string): string {
    let modifier =  abbreviation;

    switch(modifier) {
      case 'BX':
          modifier = 'Box'
        break;
      case 'KB':
          modifier = 'KeyBox'
        break;
      case 'PB':
          modifier = 'PowerBox'
        break;
      case 'KW':
          modifier = 'KeyWheel'
        break;
      default:
          modifier = 'Straight'
        break;
    }

    return modifier;
  }

  poolCheckPerLegs(pool: string): number {
    let betPerLegs = 0;

    switch(pool) {
      case 'WIN':
      case 'PLC':
      case 'SHW':
        betPerLegs = 1;
      break;

      case 'EX':
      case 'QU':
        betPerLegs = 2;
      break;

      case 'TRI':
        betPerLegs = 3;
      break;

      case 'SPR':
        betPerLegs = 4;
      break;

      default:
      break;
    }

    return betPerLegs;
  }

  convertLegRange(legs?: number, poolId?: string, modifier?: string): any[] {

    this.legResult = [];

    // let pool check first
    if (poolId === 'GSL') {
      for (let i=1; i<=4; i++) {
        this.legResult.push(i);
      }
      return this.legResult;
    }

    if (poolId === 'DBL') {
      for (let i=1; i<=2; i++) {
        this.legResult.push(i);
      }
      return this.legResult;
    }

    const startsWithPK = /^PK/.test(poolId || '');
    const wordWithPK = /^PICK|Pick|pick/.test(this.selectedPool.PoolName || '');
    if (startsWithPK || wordWithPK) {
      // const match = poolId?.match(/(\d)$/);
      const match = poolId?.match(/(\d+)$/);
      if (match) {
        for (let i=1; i<=Number(match[1]); i++) {
          this.legResult.push(i);
        }
        return this.legResult;
      }
    }

    switch (modifier) {
      case '':
      case 'KB':
      case 'PB':
      case 'DutchCost':
      case 'ABC':
        for (let i=1; i<=(legs||0); i++) {
          this.legResult.push(i);
        }
      break;

      case 'BX':
        this.legResult.push(1);
      break;

      case 'KW':
        for (let i=1; i<=2; i++) {
          this.legResult.push(i);
        }
      break;

      default:
    }

    return this.legResult;
  }

  // bet section
  showBet(betTapTriggered?: boolean): void {
    // console.log('RACE:onchanges::showBet:', betTapTriggered)
    // show bet when user tap selector
    // based on active runners
    let showBet = false;
    // const betSection = this.elementRef.nativeElement.querySelector('.bet-footer-section');
    const divLegs = this.elementRef.nativeElement.querySelectorAll(
      '.wager-content .waging-section .table-bet .content-bet .bet i'
    );
    divLegs.forEach((leg: HTMLElement) => {
      if (leg?.classList.contains('active')) {
        showBet = true;
        return;
      }
    });

    if (showBet && betTapTriggered) {
      // betSection.classList.add('active');
      this.commonFacade.setIsShowFooter(false);
      this.wagerFacade.setIsShowBetPreview(true);
    }
    else {
      // betSection.classList.remove('active');
      this.commonFacade.setIsShowFooter(true);
      this.wagerFacade.setIsShowBetPreview(false);
    }

    // if (this.selectedPool) {
    //   // if (this.storeStructure.length === this.poolCheckPerLegs(this.selectedPool.PoolId))
    //   // if (this.storeStructure.length === this.selectedPool.Legs)
    //   if (this.storeStructure.length === this.legResult.length && this.betTotal())
    //     this.cantBet = false;
    //   else
    //     this.cantBet = true;
    // }

    this.legs = this.transformRunners(this.storeStructure);

    const runnersEnmList = this.transformLegsRunners(this.storeStructure);

    if (this.selectedPool !== undefined && runnersEnmList) {
      const bets = calcBets(
        this.convertAbbreToWords(this.selectedModifier),
        this.selectedPool.Legs,
        this.selectedPool.Combine,
        runnersEnmList,
        this.baseAmount,
        this.selectedPool.Maximum,
        this.selectedPool.Unordered,
        this.selectedPool.PoolRaces
      )
      if (bets) {
        this.bets = bets;
      }
      else {
        this.bets = 0;
      }

      const startsWithPK = /^PK/.test(this.selectedPool.PoolId || '');
      const wordWithPK = /^PICK|Pick|pick/.test(this.selectedPool.PoolName || '');
      if (
        this.selectedPool.PoolId === 'GSL' ||
        this.selectedPool.PoolId === 'DBL' ||
        startsWithPK || wordWithPK
      ) {
        this.convertLegRange(
          this.selectedPool.Legs,
          this.selectedPool?.PoolId,
          this.selectedModifier
        );
      }

    }

    //PMM-316 fix already included
    if (this.selectedPool) {
      // if (this.storeStructure.length === this.poolCheckPerLegs(this.selectedPool.PoolId))
      // if (this.storeStructure.length === this.selectedPool.Legs)
      if (
          this.storeStructure.length === this.legResult.length &&
          this.betTotal() &&
          this.selectedRace.RaceStatus !== 1 &&
          this.selectedRace.RaceStatus !== 2 &&
          this.selectedRace.RaceStatus !== 4 &&
          this.selectedEvent.ToteResponse.EventDetail.EventStatus !== 'Closed'
          // &&
          // (
          //   this.betTotal() <= this.selectedPool.WBMaximum &&
          //   this.betTotal() >= this.selectedPool.WagerMinimum
          // )
        )
        this.cantBet = false;
      else
        this.cantBet = true;
    }

    // init dutch
    if (this.dutchROI) {
      this.dutchTicket = '';
      this.dutchROI = '';
      this.dutchAbcErrorMsg = '';
    }

    if (this.selectedModifier.toLowerCase() === 'dutchcost') {
      this.checkWageringJurisdiction(this.selectedEvent?.ToteResponse?.EventDetail?.EventId);
      this.buildDutchWager();
    }

    // init abc
    if (this.abcTotalAmount)
      this.abcTotalAmount = 0;

    if (this.selectedModifier.toLowerCase() === 'abc') {
      this.checkWageringJurisdiction(this.selectedEvent?.ToteResponse?.EventDetail?.EventId);
      this.buildAbcWager();
    }
  }

  closeBet(): void {
    // const betSection = this.elementRef.nativeElement.querySelector('.bet-footer-section');
    // betSection.classList.remove('active');
    this.commonFacade.setIsShowFooter(true);
    this.wagerFacade.setIsShowBetPreview(false);
  }

  async betAmount(): Promise<void> {
    this.modal = await this.modalCtrl.create({
      component: BetAmountComponent,
      cssClass: 'bet-amount',
      componentProps: {
        pool: this.selectedPool
      }
    });

    this.modal.onDidDismiss().then((res) => {
      if (!res.data) return;

      if (res.data.amount) {
        this.baseAmount = Number(res.data.amount);
      }

      this.cdRef.markForCheck();
    });

    this.modal.present();
  }

  async betNow(betType: string, payload?: any): Promise<void> {

    if (this.cantBet) {
      this.showAlertInfo('Error', 'Failed to validate ticket. Race not Open.', 'Close', 0);
      return;
    }

    let betStackTicket: IBetStackTicket = {};
    let betTicket: IBetTicket = {};
    if (betType === 'save-bet') {
      betStackTicket = {
        ...this.betStackTicketPayload,
        RunId: this.selectedEvent.ToteResponse.RunId,
        EventId: this.selectedEvent.ToteResponse.EventDetail.EventId,
        RaceId: this.selectedRace.RaceId,
        BaseAmount: this.baseAmount,
        PoolId: this.selectedPool.PoolId,
        Modifier: this.getModId(this.selectedModifier),
        Runners: this.legs,
        Total: this.betTotal()
      }

      if (payload) {
        if (payload.typeIs === 'dutch') {

          const extractWagerData = _.map(
            _.filter(payload.dutchTicket.Wagers, (item) => !item.Error),
            (item) => _.pick(item, ['PoolId', 'BaseAmount', 'Modifier', 'Legs', 'Bets', 'Total'])
          );

          const runners = _.map(extractWagerData, (item) => ({
            // Auto: _.get(item.Legs, 'Auto', false),
            Auto: _.get(item.Legs[0], 'Auto', false),
            Runners: _.map(item.Legs, 'Runners').join(','),
          }));

          const checkWagerModifier = _.forEach(extractWagerData, wager => {
            wager.Modifier = (
              this.modifierEnam.indexOf(wager.Modifier) < 0 ||
              this.modifierEnam.indexOf(wager.Modifier) > 6
               ?
              0
               :
              this.modifierEnam.indexOf(wager.Modifier)
            )
          });

          const cleanWagerData = _.forEach(checkWagerModifier, wager => {
            _.forEach(wager.Legs, legItem => {
              if (_.isArray(legItem.Runners)) {
                legItem.Runners = legItem.Runners.join(", ");
              }
            });
          });

          betStackTicket.Runners = runners;
          betStackTicket.BaseAmount = this.dutchTicket.calcAmount();
          betStackTicket.Total = this.dutchTicket.calcAmount();
          betStackTicket.Wagers = cleanWagerData;
          betStackTicket.DutchType = payload.dutchTicket.DutchType;
          betStackTicket.DutchProjections = payload.dutchTicket.DutchProjections;
        }

        if (payload.typeIs === 'abc') {

          const extractWagerData = _.map(
            _.filter(payload.abcTicket.Wagers, (item) => !item.Error),
            (item) => _.pick(item, ['PoolId', 'BaseAmount', 'Modifier', 'Legs', 'Bets', 'Total'])
          );

          betStackTicket.Total = _.sumBy(extractWagerData, 'Total');

          const checkWagerModifier = _.forEach(extractWagerData, wager => {
            wager.Modifier = (
              this.modifierEnam.indexOf(wager.Modifier) < 0 ||
              this.modifierEnam.indexOf(wager.Modifier) > 6
               ?
              0
               :
              this.modifierEnam.indexOf(wager.Modifier)
            )
          });

          const cleanWagerData = _.forEach(checkWagerModifier, wager => {
            _.forEach(wager.Legs, legItem => {
              if (_.isArray(legItem.Runners)) {
                legItem.Runners = legItem.Runners.join(", ");
              }
            });
          });

          betStackTicket.Wagers = cleanWagerData;
          // betStackTicket.DutchType = 0;
          betStackTicket.DutchType = payload.abcTicket.DutchType;
        }
      }

    }
    else {
      betTicket = {
        ...this.betTicketPayload,
        TicketAmount: this.baseAmount * this.bets,
        RunId: this.selectedEvent.ToteResponse.RunId,
        ToteTicketRequest: {
          ...this.betTicketPayload?.ToteTicketRequest,
          EventId: this.selectedEvent.ToteResponse.EventDetail.EventId,
          RaceId: this.selectedRace.RaceId,
          Wagers: [
            // ...this.betTicketPayload?.ToteTicketRequest?.Wagers || [],
            {
              ...this.betTicketPayload?.ToteTicketRequest?.Wagers?.[
                0
              ],
              PoolId: this.selectedPool.PoolId,
              // RaceId: this.selectedRace.RaceId,
              Bets: this.bets,
              Legs: this.legs,
              Modifier: this.getModId(this.selectedModifier),
              // BaseAmount: this.baseAmount.toString(),
              BaseAmount: this.baseAmount,
              // Total: this.baseAmount * bets
              Total: this.betTotal()
            }
          ]
          // Wagers: _.map(this.betTicketPayload?.ToteTicketRequest?.Wagers, (wager)=>{
          //   console.log(wager);
          //   if(wager.RaceId == this.selectedRace.RaceId) return {
          //     ...wager,
          //     PoolId: this.selectedPool.PoolId
          //   }
          //   else {
          //     return wager;
          //   }
          // })
        }
      }

      if (payload) {
        if (payload.typeIs === 'dutch' && betTicket?.ToteTicketRequest !== undefined) {

          const extractWagerData = _.map(
            _.filter(payload.dutchTicket.Wagers, (item) => !item.Error),
            (item) => _.pick(item, ['PoolId', 'BaseAmount', 'Modifier', 'Legs', 'Bets', 'Total'])
          );

          const checkWagerModifier = _.forEach(extractWagerData, wager => {
            wager.Modifier = (
              this.modifierEnam.indexOf(wager.Modifier) < 0 ||
              this.modifierEnam.indexOf(wager.Modifier) > 6
               ?
              0
               :
              this.modifierEnam.indexOf(wager.Modifier)
            )
          });

          const cleanWagerData = _.forEach(checkWagerModifier, wager => {
            _.forEach(wager.Legs, legItem => {
              if (_.isArray(legItem.Runners)) {
                legItem.Runners = legItem.Runners.join(",");
              }
            });
          });

          betTicket.TicketAmount = this.dutchTicket.calcAmount();
          betTicket.ToteTicketRequest.Wagers = cleanWagerData;
          betTicket.DutchType = payload.dutchTicket.DutchType;
          betTicket.DutchProjections = payload.dutchTicket.DutchProjections;
        }

        if (payload.typeIs === 'abc' && betTicket?.ToteTicketRequest !== undefined) {

          const extractWagerData = _.map(
            _.filter(payload.abcTicket.Wagers, (item) => !item.Error),
            (item) => _.pick(item, ['PoolId', 'BaseAmount', 'Modifier', 'Legs', 'Bets', 'Total'])
          );

          betTicket.TicketAmount = _.sumBy(extractWagerData, 'Total');

          const checkWagerModifier = _.forEach(extractWagerData, wager => {
            wager.Modifier = (
              this.modifierEnam.indexOf(wager.Modifier) < 0 ||
              this.modifierEnam.indexOf(wager.Modifier) > 6
               ?
              0
               :
              this.modifierEnam.indexOf(wager.Modifier)
            )
          });

          const cleanWagerData = _.forEach(checkWagerModifier, wager => {
            _.forEach(wager.Legs, legItem => {
              if (_.isArray(legItem.Runners)) {
                legItem.Runners = legItem.Runners.join(",");
              }
            });
          });

          betTicket.ToteTicketRequest.Wagers = cleanWagerData;
          // betTicket.DutchType = 0;
          betTicket.DutchType = payload.abcTicket.DutchType;
        }
      }

    }

    if (this.sessionService.getSubscription()) {
      betTicket.CustomerId = this.sessionService.getSubscription();
    }

    if (this.geoLocation === undefined) {
      const result = await this.geoLocationService.askPermissionGeoLocation();

      if ('latitude' in result && 'longitude' in result) {
        if (result === undefined) return;

        if (
          (result?.latitude === 0) || (result?.longitude === 0)
          || ((result?.latitude as any) === '0') || ((result?.longitude as any) === '0')
          || (result?.latitude === 0.0) || (result?.longitude === 0.0)
          || ((result?.latitude as any) === '0.0') || ((result?.longitude as any) === '0.0')
          || !result?.latitude || !result?.longitude
        ) return;

        if (result.latitude && result.longitude) {
          this.wagerFacade.setGeoLocation({
            CLat: result.latitude, CLon: result.longitude
          },
          'RunnerComponent:betNow');

          if (betType === 'save-bet') {
            betStackTicket = {
              ...betStackTicket,
              Location: {
                ...betStackTicket?.Location,
                CLat: result.latitude,
                CLon: result.longitude
              }
            };
          }
          else {
            betTicket = {
              ...betTicket,
              Location: {
                ...betTicket?.Location,
                CLat: result.latitude,
                CLon: result.longitude
              }
            };
          }

        }
      }
      else {
        if (result.showDeviceSetting)
          this.showAlertError(result.msg, 'Yes', true);
        else
          this.showAlertError(result.msg, '', true);
        return;
      }

    }
    else {
      const latitude = this.geoLocation.CLat || undefined;
      const longitude = this.geoLocation.CLon || undefined;

      if (
        (latitude === 0) || (longitude === 0)
        || ((latitude as any) === '0') || ((longitude as any) === '0')
        || (latitude === 0.0) || (longitude === 0.0)
        || ((latitude as any) === '0.0') || ((longitude as any) === '0.0')
        || !latitude || !longitude
      ) return;


      if (latitude && longitude) {
        if (betType === 'save-bet') {
          betStackTicket = {
            ...betStackTicket,
            Location: {
              ...betStackTicket?.Location,
              CLat: latitude,
              CLon: longitude
            }
          };
        }
        else {
          betTicket = {
            ...betTicket,
            Location: {
              ...betTicket?.Location,
              CLat: latitude,
              CLon: longitude
            }
          };
        }
      }
    }

    if (betType === 'save-bet')
      this.execSaveBet(betStackTicket);
    else
      this.execBetNow(betTicket);

  }

  execSaveBet(betStackTicket: IBetStackTicket): void {

    if (this.isExceedsSaveBetErr)
      this.isExceedsSaveBetErr = false;

    if (this.isGenericSaveBetErr)
      this.isGenericSaveBetErr = false;

    if (
      this.selectedModifier.toLowerCase() === 'dutchcost' ||
      this.selectedModifier.toLowerCase() === 'abc'
    ) {
      _.forEach(betStackTicket.Wagers, ticket => {
        const payload = {
          ...betStackTicket,
          Bets: ticket.Bets,
          BaseAmount: ticket.BaseAmount,
          Wagers: [ticket],
          Total: ticket.Total
        };

        if (
          this.selectedModifier.toLowerCase() === 'dutchcost' ||
          this.selectedModifier.toLowerCase() === 'abc'
        )
          payload.Runners = ticket.Legs

        // console.log('payload ', payload);
        this.wagerFacade.saveBetAPI(payload);
      });
    } else {
      this.wagerFacade.saveBetAPI(betStackTicket);
    }
    // this.wagerFacade.saveBetAPI(betTicket);
    this.subsGetBetResponse = this.wagerFacade.isSaveBetSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe( async(callback) => {
      // console.log(callback);
      if (callback.isSuccess !== undefined) {

        this.modal = await this.modalCtrl.create({
          component: BetSlipModalComponent,
          cssClass: 'betslip',
          componentProps: {
            typeBet: 'save-bet'
          }
        });
        this.modal.present();

        this.commonFacade.setIsShowFooter(true);
        this.wagerFacade.setIsShowBetPreview(false);
        // const betSection = this.elementRef.nativeElement.querySelector('.bet-footer-section');
        // betSection.classList.remove('active');

        const error = callback.response?.WageringResponses?.[0]?.Response?.Error?.Message ?
          callback.response?.WageringResponses?.[0]?.Response?.Error?.Message
        :
          callback.response?.WageringResponses?.[0]?.Response?.Wagers?.[0]?.Error?.Message;

        this.isExceedsSaveBetErr = _.some(
          callback.response?.WageringResponses,
          {'Error': 'Exceeds loss limit.'}
        );

        if (this.isExceedsSaveBetErr) {
          this.showAlertError('Exceeds loss limit.', '', true);
        }

        this.isGenericSaveBetErr = _.some(callback.response?.WageringResponses, (item) =>
          item?.Error?.includes('Please contact your administrator for more information.')
        );

        if (this.isGenericSaveBetErr) {
          this.showAlertError('Invalid ticket or wager. Please adjust selections.', '', true);
        }

        if (error) {
          this.showAlertError(error, '', true);
        }

        if (this.isClearWager) {
          this.storeStructure = [];
          this.clearActiveAllLeg();
          this.clearLegRoundSelector();
        }

        // this.wagerFacade.getBetsAPI({
        //   runId: this.selectedEvent.ToteResponse.RunId,
        //   ticketStatus: 1,
        //   offset: 0,
        //   next: 500
        // }, 'RunnerComponent:betNow');
      }

      this.subsGetBetResponse?.unsubscribe();
    });
  }

  execBetNow(betTicket: IBetTicket): void {

    if (this.isExceedsBetNowErr)
      this.isExceedsBetNowErr = false;

    if (this.isGenericBetNowErr)
      this.isGenericBetNowErr = false;

    this.wagerFacade.betNowAPI(betTicket);
    this.subsGetBetResponse = this.wagerFacade.isBetNowSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe( async(callback) => {
      // console.log(callback);

      if (callback?.response?.error) {
        if (callback?.response?.error?.MessageCode.includes('geolocation.clatclon.null')) {
          this.showAlertGeoLocation(callback?.response?.error?.Message);
          this.subsGetBetResponse?.unsubscribe();
          return;
        }
      }

      if (callback.isSuccess !== undefined) {

        this.modal = await this.modalCtrl.create({
          component: BetSlipModalComponent,
          cssClass: 'betslip',
          componentProps: {
            typeBet: 'bet-now'
          }
        });
        this.modal.present();

        this.commonFacade.setIsShowFooter(true);
        this.wagerFacade.setIsShowBetPreview(false);
        // const betSection = this.elementRef.nativeElement.querySelector('.bet-footer-section');
        // betSection.classList.remove('active');

        const error = callback.response?.WageringResponses?.[0]?.Response?.Error?.Message ?
          callback.response?.WageringResponses?.[0]?.Response?.Error?.Message
        :
          callback.response?.WageringResponses?.[0]?.Response?.Wagers?.[0]?.Error?.Message;

        this.isExceedsBetNowErr = _.some(
          callback.response?.WageringResponses,
          {'Error': 'Exceeds loss limit.'}
        );

        // const exceedsErr = _.filter(
        //   callback.response?.WageringResponses,
        //   {'Error': 'Exceeds loss limit.'}
        // ).length;

        if (this.isExceedsBetNowErr) {
          this.showAlertError('Exceeds loss limit.', '', true);
        }

        this.isGenericBetNowErr = _.some(callback.response?.WageringResponses, (item) =>
          item?.Error?.includes('Please contact your administrator for more information.')
        );
        // _.some(
        //   callback.response?.WageringResponses,
        //   {'Error': 'Please contact your administrator for more information.'}
        // );

        if (this.isGenericBetNowErr) {
          this.showAlertError('Invalid ticket or wager. Please adjust selections.', '', true);
        }

        if (error) {
          this.showAlertError(error, '', true);
        }

        if (this.isClearWager) {
          this.storeStructure = [];
          this.clearActiveAllLeg();
          this.clearLegRoundSelector();
        }

        // this.wagerFacade.getBetsAPI({
        //   runId: this.selectedEvent.ToteResponse.RunId,
        //   ticketStatus: 3,
        //   offset: 0,
        //   next: 500
        // }, 'RunnerComponent:betNow');
      }

      this.subsGetBetResponse?.unsubscribe();
    });
  }

  async openFunding(): Promise<void> {
    this.modal = await this.modalCtrl.create({
      component: FundingComponent,
    });
    this.modal.present();
  }

  hideRoundSelector(leg: any, runnerId: any): boolean {
    if (!this.dblPkArray) return true;

    let currentLeg: any = '';
    if (this.dblPkArray !== undefined && this.dblPkArray) {
      currentLeg = _.get(this.dblPkArray, `[${leg-1}]`, {});
      // console.log(currentLeg);
      // console.log(this.dblPkArray);
      // this.dblPkArray = [];
    }
    // console.log(this.dblPkArray);
    // console.log(currentLeg);
    if (currentLeg !== undefined && currentLeg) {
      // console.log(runnerId, ' index or current runnderId');
      // console.log(currentLeg.Runners.length, 'runner length');
      // console.log(currentLeg.Runners);
      if (runnerId <= currentLeg.Runners.length) {
        return true;
      }
      else {
        return false;
      }
    }
    return true;
  }

  trackByRunners(index: number, item: any) {
    return item.RunnerId;
  }

  trackByEntries(index: number, item: any) {
    return item.Position;
  }

  async showAlertInfo(hdr: string, msg: string, btn: string, status: number): Promise<void> {
    this.showAlertInfoHandler = await this.alertCtrl.create({
      header: hdr,
      message: msg,
      buttons: [
        {
          text: btn,
          handler: () => {
            this.ngZone.run(()=>{
              this.modalCtrl.dismiss();
              if (status) {
                this.openFunding();
              }
            });
          }
        }
      ]
    });

    await this.showAlertInfoHandler.present();
  }

  async confirmBet(betType: string): Promise<void> {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:confirmBet', false);
      return;
    }

    if (!this.hasPermission()) {

      // encase
      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('Info', 'You are not an Identified User.', 'Close', 0);
      }

      return;
    }

    if (this.cantBet) {
      this.showAlertInfo('Error', 'Failed to validate ticket. Race not Open.', 'Close', 0);
      return;
    }

    if (!this.baseAmount || this.baseAmount < -1) {
      this.showAlertInfo('Error', 'Please enter valid amount.', 'Close', 0);
      return;
    }

    // if (
    //   this.selectedModifier.toLowerCase() === 'dutchcost' &&
    //   (this.dutchTotalAmount) > this.balanceAmount &&
    //   betType !== 'save-bet' &&
    //   (!this.requireConfirmation || this.requireConfirmation)
    // ) {
    //   this.showAlertInfo('Info', 'Insufficient Funds.', 'Deposit Now', 1);
    //   return;
    // }

    // if (
    //   this.selectedModifier.toLowerCase() === 'abc' &&
    //   (this.abcTotalAmount) > this.balanceAmount &&
    //   betType !== 'save-bet' &&
    //   (!this.requireConfirmation || this.requireConfirmation)
    // ) {
    //   this.showAlertInfo('Info', 'Insufficient Funds.', 'Deposit Now', 1);
    //   return;
    // }

    if (
      (
        this.selectedModifier.toLowerCase() !== 'dutchcost' &&
        this.selectedModifier.toLowerCase() !== 'abc'
      ) &&
      (this.baseAmount * this.bets) > this.balanceAmount &&
      betType !== 'save-bet' &&
      (!this.requireConfirmation || this.requireConfirmation)
    ) {
      this.showAlertInfo('Info', 'Insufficient Funds.', 'Deposit Now', 1);
      return;
    }

    this.isProcessingBet = true;

    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }

    this.setTimer = setTimeout( async() => {
      if (this.requireConfirmation) {

        if (
          betType !== 'save-bet' &&
          this.selectedModifier.toLowerCase() === 'dutchcost'
        ) {

          const runnersEnmList = this.transformLegsRunners(this.storeStructure);
          const dutchEnum = this.dutchEnam.indexOf(this.selectedModifier);
          const events = this.events;
          const selectedRace = this.selectedRace;
          const selectedEvent = this.selectedEvent;
          const maxWagerTotal = this.maxWagerTotal;
          const isBlockJurisdiction = this.isBlockJurisdiction;
          const isBlockJurisdictionMsg = this.isBlockJurisdictionMsg;

          this.modal = await this.modalCtrl.create({
            component: DutchComponent,
            cssClass: 'dutch-detail',
            componentProps: {
              eventName: this.selectedEvent.eventName,
              dutchTicket: this.dutchTicket,
              poolMatrix: this.poolMatrix[this.selectedPool?.PoolId]?.response?.ToteResponse,
              baseAmount: this.baseAmount,
              balanceAmount: this.balanceAmount,
              totalCost: this.dutchTicket.calcAmount(),
              // totalCost: this.betTotal(),
              pool: this.selectedPool,
              modifier: this.selectedModifier,
              selectedRunners: this.storedSelectedRunners,

              // for dynamic total cost & others
              dutchEnum,
              runnersEnmList,
              defaultModifier: 'Straight',
              events,
              selectedRace,
              selectedEvent,
              maxWagerTotal,
              isBlockJurisdiction,
              isBlockJurisdictionMsg
            }
          });

          this.modal.onDidDismiss().then((res) => {
            if (!res.data) return;

            this.betNow(res.data.betType, res.data);
            this.cdRef.markForCheck();
          });

          this.modal.present();

          this.commonFacade.setIsShowFooter(true);
          this.wagerFacade.setIsShowBetPreview(false);

          this.setTimer = 0;
          this.isProcessingBet = false;
          return;
        }
      }

      if (this.requireConfirmation) {

        if (
          betType !== 'save-bet' &&
          this.selectedModifier.toLowerCase() === 'abc'
        ) {

          this.modal = await this.modalCtrl.create({
            component: AbcComponent,
            cssClass: 'abc-detail',
            componentProps: {
              eventName: this.selectedEvent.eventName,
              abcTicket: this.abcTicket,
              selectedRace: this.selectedRace,
              balanceAmount: this.balanceAmount,
              betNow: async(data: any) => this.betNow(data.betType, data),
            }
          });

          this.modal.onDidDismiss().then((res) => {
            if (!res.data) return;

            this.betNow(res.data.betType, res.data);
            this.cdRef.markForCheck();
          });

          this.modal.present();

          this.commonFacade.setIsShowFooter(true);
          this.wagerFacade.setIsShowBetPreview(false);

          this.setTimer = 0;
          this.isProcessingBet = false;
          return;
        }
      }

      if (this.isWagerLimit) {
        if (this.baseAmount > this.wagerLimit) {
            const msg = 'Total wagered amount ' +
              this.baseAmount + ' is greater than the user limit of ' + this.wagerLimit;

            this.showAlertWagerLimit('Wager Limit', msg, 'Continue', betType);

          return;
        }
      }

      this.isRequireConfirmActive(betType);

      // if (this.requireConfirmation) {
      //   const alert = await this.alertCtrl.create({
      //     header: 'Confirm',
      //     message: 'Submit or Close.',
      //     buttons: [
      //       {
      //         text: 'Close',
      //         role: 'cancel',
      //         handler: () => {
      //           this.setTimer = 0;
      //           this.isProcessingBet = false;
      //           this.cdRef.detectChanges();
      //         }
      //       },
      //       {
      //         text: 'Submit',
      //         handler: () => {
      //           this.ngZone.run(()=>{
      //             this.betNow(betType);
      //             this.modalCtrl.dismiss();
      //             this.setTimer = 0;
      //             this.isProcessingBet = false;
      //           });
      //         }
      //       }
      //     ]
      //   });

      //   await alert.present();
      // }
      // else {
      //   this.betNow(betType);
      //   this.setTimer = 0;
      //   this.isProcessingBet = false;
      // }

    }, 1000);

  }

  async isRequireConfirmActive(betType: string): Promise<void> {
    if (this.requireConfirmation) {
      this.isRequireConfirmActiveHandler = await this.alertCtrl.create({
        header: 'Confirm',
        message: 'Submit or Close.',
        buttons: [
          {
            text: 'Close',
            role: 'cancel',
            handler: () => {
              this.setTimer = 0;
              this.isProcessingBet = false;
              this.cdRef.detectChanges();
            }
          },
          {
            text: 'Submit',
            handler: () => {
              this.ngZone.run(()=>{

                if (
                  this.selectedModifier.toLowerCase() === 'dutchcost'
                ) {
                  this.betNow(
                    betType,
                    {
                      betType,
                      typeIs: 'dutch',
                      dutchTicket: this.dutchTicket
                    }
                  );
                }
                else if (
                  this.selectedModifier.toLowerCase() === 'abc'
                ) {
                  this.betNow(
                    betType,
                    {
                      betType,
                      typeIs: 'abc',
                      abcTicket: this.createNewABCTicket(this.abcTicket)
                    }
                  );
                }
                else {
                  this.betNow(betType);
                }

                this.modalCtrl.dismiss();
                this.setTimer = 0;
                this.isProcessingBet = false;
              });
            }
          }
        ]
      });

      await this.isRequireConfirmActiveHandler.present();
    }
    else {

      if (
        this.selectedModifier.toLowerCase() === 'dutchcost'
      ) {
        this.betNow(
          betType,
          {
            betType,
            typeIs: 'dutch',
            dutchTicket: this.dutchTicket
          }
        );
      }
      else if (
        this.selectedModifier.toLowerCase() === 'abc'
      ) {
        this.betNow(
          betType,
          {
            betType,
            typeIs: 'abc',
            abcTicket: this.createNewABCTicket(this.abcTicket)
          }
        );
      }
      else {
        this.betNow(betType);
      }

      this.setTimer = 0;
      this.isProcessingBet = false;
    }
  }

  createNewABCTicket(isIndividual: boolean): any {
    const wagersList = [];
    for(let i=0;i<this.abcTicket.length;i++) {
      if(
        (this.abcTicket[i].submitted === undefined || this.abcTicket[i].submitted === false)
        &&
        (this.abcTicket[i].saved === undefined || this.abcTicket[i].saved === false)
        &&
        (this.abcTicket[i].removed === undefined || this.abcTicket[i].removed === false)
      ) {
        for(let j = 0; j < this.abcTicket[i].ABCTicket.Wagers.length; j++) {
          wagersList.push(this.abcTicket[i].ABCTicket.Wagers[j]);
        }
      }
    }

    return new ticketRequest(
      this.abcTicket[0].ABCTicket.RunId,
      this.abcTicket[0].ABCTicket.EventId,
      this.abcTicket[0].ABCTicket.RaceId,
      wagersList,
      isIndividual ? 0 : 3,
      undefined
    );
  }

  async replayVideo(): Promise<void> {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('RunnerComponent:replayVideo', false);
    }

    if (!this.hasPermission()) {

      if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
        this.router.navigate(['login']);
      }
      else {
        this.showAlertInfo('Info', 'You are not an Identified User.', 'Close', 0);
      }

      return;
    }
    // else {
    //   this.showAlertInfo('Info', 'The countdown to your next big win starts soon!', 'close', 0);
    // }

    this.showReplaysRunnerTable();

    // this.wagerFacade.getEventRaceVideoReplay(
    //   'RaceFinalComponent:replayVideo',
    //   {
    //     toteEventId: this.eventId,
    //     toteRaceId: this.raceId,
    //     raceDay: this.toDate(
    //       new Date(this.selectedEvent?.ToteResponse?.EventDetail?.EventInfo),
    //       2
    //     ).toString(),
    //     width: 720,
    //     height: 576
    //   }
    // );

  }

  async showReplaysRunnerTable(): Promise<void> {

    this.indexGetReplays = 0;
    // this.indexPostReplays = 0;
    this.runnerWithReplays = [];

    if (this.selectedRace.TrackType === undefined)
      return;

    const entriesArray = this.currentEntries.toArray();

    from(entriesArray).pipe(
      filter((item) => {
        return item && item.nativeElement;
      }),
      concatMap((item) => {
        this.indexGetReplays = this.indexGetReplays + 1;

        const runnerId = item.nativeElement.parentElement.querySelector(
          'div > div:nth-child(1) > div .pos'
        );

        const runnerName = item.nativeElement.parentElement.querySelector(
          'div > div:nth-child(2) > div > p > span'
        );

        const id = runnerId ? runnerId.innerHTML.trim() : null;
        const name = runnerName ? runnerName.innerHTML.trim() : null;

        if (name && id) {

          this.runnerWithReplays.push({
            runnerId: Number(id),
            name: name,
            availableReplays: [],
          });

          this.wagerFacade.getReplays(
            'RunnerComponent:showReplaysRunnerTable',
            {
              raceDay: '',
              trackType: this.replayTypes[this.selectedRace.TrackType || 0],
              runnerName: name,
              runnerName2: '',
            }
          )
        }

        return [];

      })
    ).subscribe({
      next: (result) => {
        // console.log('Call completed with result:', result);
      },
      error: (error) => {
        // console.error('Error in API call:', error);
      },
      complete: async() => {
        // console.log('All calls completed.');
        this.modal = await this.modalCtrl.create({
          component: RunnerReplaysModalComponent,
          cssClass: 'runner-replays',
          componentProps: {
            indexGetReplays: this.indexGetReplays,
            runnerWithReplays: this.runnerWithReplays
          }
        });
        this.modal.present();
      },
    });
  }

  // showReplaysRunnerTable(): void {
  //   console.log('this.currentRunners ', this.currentEntries);
  //   let i = 0;
  //   this.currentEntries.forEach((item, index) => {
  //     console.log(item);
  //     console.log(item.nativeElement.querySelector('div > div:nth-child(2) > div > p > span').innerHTML);
  //     const runnerName = item.nativeElement.querySelector(
  //       'div > div:nth-child(2) > div > p > span'
  //     ).innerHTML;

  //     if (runnerName && !i) {
  //       this.wagerFacade.getReplays(
  //         'RunnerComponent:showReplaysRunnerTable',
  //         {
  //           raceDay: '',
  //           trackType: this.selectedRace.TrackType,
  //           runnerName: runnerName.trim(),
  //           runnerName2: '',
  //         }
  //       );
  //     }
  //     i++;
  //   });
  // }

  async showAlertGeoLocation(error: string): Promise<void> {
    this.showAlertGeoLocationHandler = await this.alertCtrl.create({
      header: 'Error',
      message: error,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Get new location',
          handler: () => {
            this.ngZone.run(async()=>{
              const result = await this.geoLocationService.askPermissionGeoLocation();

              if ('latitude' in result && 'longitude' in result) {
                if (result === undefined)
                  return;

                if (result.latitude && result.longitude) {
                  this.wagerFacade.setGeoLocation({
                    CLat: result.latitude, CLon: result.longitude
                  },
                  'RunnerComponent:showAlertGeoLocation');
                }
              }
              else
                this.showAlertError(result.msg, '', true);

            });
          }
        }
      ]
    });

    await this.showAlertGeoLocationHandler.present();
  }

  async showAlertWagerLimit(hdr: string, msg: string, btn: string, type: string): Promise<void> {
    this.showAlertWagerLimitHandler = await this.alertCtrl.create({
      header: hdr,
      message: msg,
      buttons: [
        {
          text: btn,
          handler: () => {
            this.ngZone.run(()=>{
              this.isRequireConfirmActive(type);
              this.modalCtrl.dismiss();
              this.setTimer = 0;
              this.isProcessingBet = false;
            });
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            this.ngZone.run(()=>{
              this.setTimer = 0;
              this.isProcessingBet = false;
              this.cdRef.detectChanges();
            });
          }
        },
      ]
    });

    await this.showAlertWagerLimitHandler.present();
  }

  async showAlertError(error: string, btn: string, uniqueModal?: boolean): Promise<void> {

    const platform = Capacitor.getPlatform();

    this.showAlertErrorHandler = await this.alertCtrl.create({
      header: 'Error',
      message: error,
      buttons: [
        {
          text: 'Close',
          handler: () => {
            this.ngZone.run(()=>{
              if (!uniqueModal || uniqueModal === undefined)
                this.modalCtrl.dismiss();
            });
          }
        },
        {
          text: btn,
          handler: () => {
            if (btn) {
              this.ngZone.run(()=>{
                if (platform === 'android') {
                  NativeSettings.openAndroid({
                    option: AndroidSettings.Location,
                  });
                }
                this.modalCtrl.dismiss();
              });
            }
          }
        }
      ]
    });

    await this.showAlertErrorHandler.present();
  }

  extractNumber(pk: string): number {
    const match = pk.match(/\d+/);
    return match ? parseInt(match[0], 10) : NaN;
  }

  checkWageringJurisdiction(eventId: any): void {
    const country = this.sessionService.getCountry();
    const state = this.sessionService.getState();

    if (!country || !state)
      return;

    if (this.countryStateList === undefined)
      return;

    let jurisdiction: any;
    if (this.countryStateList[state] === undefined)
      jurisdiction = this.countryStateList[state];

    if (!jurisdiction)
      return;

    if (jurisdiction.WageringBlocks) {
      for (const [key, value] of Object.entries(jurisdiction.WageringBlocks)) {
        if (key.toLowerCase() === 'all') {
          this.isBlockJurisdiction = true;
          this.isBlockJurisdictionMsg = `
            ${state} Residents may not bet for ${this.selectedEvent?.eventName} per contract
          `;
        }
        else if (parseInt(key, 10) === eventId) {
          this.isBlockJurisdiction = true;
          this.isBlockJurisdictionMsg = value as string;
        }
        else if (!this.isBlockJurisdiction && key.length === 1) {
          const trackType = this.selectedEvent?.ToteResponse.EventDetail.TrackType;
          if (trackType === parseInt(key, 10)) {
            this.isBlockJurisdiction = true;
            this.isBlockJurisdictionMsg = value as string;
          }
        }

        if (this.isBlockJurisdiction) {
          break;
        }
      }
    }
  }

  // outerLength: number,
  generateNestedArray(
    nestedRunners: any,
    innerLength: number,
    setCycleA: boolean
  ) {
    this.nestedArrayABC = nestedRunners.map((runner: { RunnerId: any; }) =>
      _.times(innerLength, (legIndex) => ({
        legId: legIndex + 1,
        value: setCycleA ? 'A' : '',
        runnerId: runner.RunnerId
      }))
    );
    // this.nestedArrayABC = _.times(outerLength, () =>
    //   _.times(innerLength, (index) => ({
    //     leg: index + 1,
    //     value: setCycleA ? 'A' : ''
    //   }))
    // );
  }

  generateNestedArrayPKDbl(
    races: any[],
    legCount: number,
    setCycleA: boolean
  ) {
    this.nestedArrayABC = races
      .map((race) => {
        return race.Runners?.filter(
          (runner: { toHide: any; }) => !runner.toHide
        ).map((runner: { RunnerId: any; }) => {
          return _.times(legCount, (legIndex) => ({
            // legId: legIndex + 1,
            legId: race.RaceId,
            value: setCycleA ? 'A' : '',
            runnerId: runner.RunnerId,
            // entries: runner.Entries.map((entry: any) => ({
            //   entryId: entry.EntryId || ''
            // }))
          }));
        });
      })
      .filter(Boolean);
  }

  // dutch
  buildDutchWager(): void {

    if (this.selectedModifier.toLowerCase() === 'dutchcost') {

      if (this.poolMatrix[this.selectedPool?.PoolId] == undefined) {
        this.dutchTotalAmount = 0;
        this.dutchAbcErrorMsg = this.cantBet ?
        'Increase stake/adjust selections.'
          :
        'No valid wagers. Increase stake/adjust selections.';

        this.dutchROI = 'ROI: 0%';

        this.dutchTicket = new ticketRequest(
          '',
          '',
          '',
          [],
          '',
          ''
        );
        return;
      }

      const runnersEnmList = this.transformLegsRunners(this.storeStructure);

      this.dutchTicket = new dutchWagersService().buildDutchWagers(
        this.dutchEnam.indexOf(this.selectedModifier),
        runnersEnmList,
        'Straight',
        this.selectedPool,
        this.baseAmount,
        this.poolMatrix[this.selectedPool?.PoolId]?.response?.ToteResponse,
        this.events,
        this.selectedRace,
        this.selectedEvent,
        this.maxWagerTotal,
        this.isBlockJurisdiction,
        this.isBlockJurisdictionMsg
      );

      this.runnersWithStake = new winDutchService().getWinDutchData(
        this.dutchEnam.indexOf(this.selectedModifier),
        runnersEnmList,
        this.baseAmount,
        this.selectedEvent,
        this.poolMatrix[this.selectedPool?.PoolId]?.response?.ToteResponse
      );

      let dutchErrorFound = false;

      if (this.dutchTicket.Wagers) {
        for (const wager of this.dutchTicket.Wagers) {
          if (wager.Error !== undefined && wager.Error !== null) {
            dutchErrorFound = true;
            break;
          }
        }
      }

      if (this.dutchTicket.calcAmount() === 0) {
        this.dutchAbcErrorMsg = this.cantBet ?
        'Increase stake/adjust selections.'
          :
        'No valid wagers. Increase stake/adjust selections.';
      }
      else if (dutchErrorFound) {
        this.dutchAbcErrorMsg = 'Invalid wager exists. Increase stake/adjust selections.';
      }
      else {
        this.dutchAbcErrorMsg = '';
      }

      if (this.dutchTicket.DutchProjections.ProjectedMinROI !== 'undefined') {
        this.dutchROI = 'ROI: ' + this.dutchTicket.DutchProjections.ProjectedMinROI + '%';
      }

      if (this.dutchTicket.Wagers.length == 0) {
        this.disableSavedBetBtn = true;
        this.disableBetNowBtn = true;
      }
      else {
        this.disableSavedBetBtn = false;
        this.disableBetNowBtn = false;
      }

      if (this.dutchTicket.calcAmount() < 1)
        this.dutchTotalAmount = 0;

      this.dutchTotalAmount = this.dutchTicket.calcAmount();
    }

  }

  // abc
  buildAbcWager(): void {

    if (this.selectedModifier.toLowerCase() === 'abc') {

      const runnersEnm = this.transformLegsRunners(this.storeStructure);
      const legsArray = _.map(runnersEnm, (runnerEnm) => new leg(false, runnerEnm));

      const runnersEnmList = _.map(runnersEnm, (nestedArray, i) =>
        _.map(nestedArray, (runnerId, z) => {
          const selector = `.table-bet .bet-content .runner-${runnerId}.leg-${i + 1}`;
          const element = this.elementRef.nativeElement.querySelector(selector);
          return (element?.innerText+'%'+runnerId) || '';
          // return ('A%'+runnerId) || '';
        })
      );

      // runnersList - 4th
      this.abcTicket = new abcWagersService().buildABCWagers(
        runnersEnmList,
        this.selectedPool,
        this.baseAmount,
        runnersEnmList,
        legsArray,
        this.selectedEvent,
        this.selectedRace,
        this.selectedModifier,
        this.isBlockJurisdiction,
        this.isBlockJurisdictionMsg
      );

      let abcErrorFound = false;
      let allTicketsvalid =  true;
      for(let i = 0; i < this.abcTicket.length; i++) {
        if (this.abcTicket[i].ABCTicket.Wagers != null) {
          for(
            let indexOfABCWager = 0;
            indexOfABCWager < this.abcTicket[i].ABCTicket.Wagers.length;
            indexOfABCWager++
          ) {
            if(this.abcTicket[i].ABCTicket.Wagers[indexOfABCWager].Error != null) {
              if(!abcErrorFound) abcErrorFound = true;
              if(
                this.abcTicket[i].ABCTicket.Wagers[indexOfABCWager].Error == 'No valid wager possible'
              ) {
                allTicketsvalid = false;
                break;
              }
            }
          }
        }
      }

      if(!allTicketsvalid){
        this.dutchAbcErrorMsg = 'Some invalid combinations exist. Increase stake or adjust selections.';
      }
      else if (
        this.abcTicket != null &&
        this.abcTicket != -1 &&
        this.abcTicket[0] != null &&
        this.abcTicket[0].ABCTicket.calcAmount() == 0
      ) {
        this.dutchAbcErrorMsg = this.cantBet ?
        'Increase stake/adjust selections.'
          :
        'No valid wagers. Increase stake/adjust selections.';
      }
      else if(abcErrorFound) {
        this.dutchAbcErrorMsg = this.cantBet ?
        'Increase stake/adjust selections.'
          :
        'No valid wagers. Increase stake/adjust selections.';
      }
      else {
        this.dutchAbcErrorMsg = '';
      }

      for(let i = 0; i < this.abcTicket.length; i++) {
        if(this.abcTicket[i].ABCTicket != null)
          this.abcTotalAmount += parseFloat(this.abcTicket[i].ABCTicket.calcAmount());
      }

      if(
        this.abcTicket != null &&
        this.abcTicket != -1 &&
        this.abcTicket[0] != null &&
        this.abcTicket[0].ABCTicket != null &&
        this.abcTicket[0].ABCTicket.Wagers[0] != null
      ) {
        // .wagerReces abcTicket[0].ABCTicket.Wagers[0].getwagerString()[2];
        // .cond abcTicket[0].ABCTicket.Wagers[0].ConditionMTPToString();
      }

      if (
        this.abcTicket != null &&
        this.abcTicket != -1 &&
        this.abcTicket[0] != null &&
        this.abcTicket[0].ABCTicket != null &&
        this.abcTicket[0].ABCTicket.Wagers.length > 0
      ) {
        this.disableSavedBetBtn = true;
        this.disableBetNowBtn = true;
      }
      else {
        this.disableSavedBetBtn = false;
        this.disableBetNowBtn = false;
      }

    }
  }

}
